<template>
  <div class="step-input-wrapper">
    <ul class="progress-boxs gutter-12 clearfix" id="buttons-tab">
      <li class="progress-box gutter-12__li grid-3--xs" :class="{active: step === 1}">
        <a class="progress-box__link org-line-btn block-btn">
          <label>1. 기본정보</label><label v-if="step === 1">(현재단계)</label>
          <div class="progress-arrow-circle">
            <img class="progress-box__img" src="/images/icon-right-arrow-big.png" alt="">
          </div>
        </a>
      </li>
      <li class="progress-box gutter-12__li grid-3--xs" :class="{active: step === 2}">
        <a class="progress-box__link org-line-btn block-btn">
          <label>2. 강좌정보</label><label v-if="step === 2">(현재단계)</label>
          <div class="progress-arrow-circle">
            <img class="progress-box__img" src="/images/icon-right-arrow-big.png" alt="">
          </div>
        </a>
      </li>
      <li class="progress-box gutter-12__li grid-3--xs" :class="{active: step === 3}">
        <a class="progress-box__link org-line-btn block-btn">
          <label>3. 등록</label><label v-if="step === 3">(현재단계)</label>
        </a>
      </li>
    </ul>

    <div v-if="step === 1">
      <div class="basic-form">
        <h2 class="basic-form-title">1. 기본정보</h2>
        <div class="inline-input-group clearfix">
          <label class="inline-input__label" for="loginid">아이디</label>
          <p class="progress__only-text" id="loginid">{{member.loginid}}</p>
        </div>

        <div class="inline-input-group clearfix">
          <label class="inline-input__label" for="realname">이름(본명)</label>
          <p class="progress__only-text" id="realname">{{member.name}}</p>
        </div>

        <div class="inline-input-group clearfix">
          <label class="inline-input__label" for="email1">이메일</label>
          <div class="f-gutter-10">
            <div class="f-gutter-10__li grid-4">
              <input type="text" name="" v-model="email1" id="email1" class="input__text" placeholder="입력해주세요"  title="email 계정입력">
            </div>
            <div class="f-gutter-10__li grid-10 text-center">@</div>
            <div class="f-gutter-10__li grid-4">
              <select class="input__select" id="emailSelectBox" v-model="email2" v-on:change="emailChange" title="email 도메인 선택">
                <option v-for="list in emailList" :value="list">{{list}}</option>
                <option value="etc">직접입력</option>
              </select>
            </div>
            <div class="f-gutter-10__li grid-4">
              <input type="text" name="" id="emailSelectBoxDirect" class="input__text" style="display: none;" v-model="etcEmailAddress" placeholder="입력해주세요"  title="email 도메인 직접입력">
            </div>
          </div>
        </div>

        <div class="inline-input-group clearfix">
          <label for="phone1" class="inline-input__label">휴대폰</label>
          <div class="f-gutter-10" id="phone1">
            <div class="f-gutter-10__li grid-3--xs">
              <select id="phone1" class="input__select" v-model="member.phone1" title="휴대폰 앞자리 선택">
                <option value="010">010</option>
                <option value="011">011</option>
                <option value="016">016</option>
                <option value="017">017</option>
                <option value="018">018</option>
                <option value="019">019</option>
              </select>
            </div>
            <div class="f-gutter-10__li grid-3--xs">
              <input type="text" name="" v-model="member.phone2" class="input__text" placeholder="입력해주세요" title="휴대폰 가운데자리 입력">
            </div>
            <div class="f-gutter-10__li grid-3--xs">
              <input type="text" name="" v-model="member.phone3" class="input__text" placeholder="입력해주세요" title="휴대폰 끝자리 입력">
            </div>
          </div>
        </div>

        <div class="inline-input-group clearfix">
          <label for="findPostCode" class="inline-input__label">주소</label>
          <div class="address-input-group">
            <input type="text" id="findPostCode" class="input__text input__text--readonly" readonly v-model="member.zipcode" title="우편번호 입력">
            <button class="address-input-group__btn" @click="findAddress">주소검색</button>
          </div>
          <div class="f-gutter-10__li">
            <div id="wrap" style="display:none;border:1px solid;width:500px;height:300px;margin:5px 0;position:relative; overflow: hidden;">
            </div>
            <div id="wrapTab" style="display:none;">
              <img src="//t1.daumcdn.net/localimg/localimages/07/postcode/320/close.png" id="btnFoldWrap" style="cursor:pointer;position:absolute;right:5px;top:50px;z-index:1;outline-color: red;" alt="접기 버튼" @click="foldDaumPostcode" @keyup.enter="foldDaumPostcodeEnter" tabIndex="0">
            </div>
          </div>
        </div>
        <div class="inline-input-group clearfix">
          <label class="inline-input__label"></label>
          <div class="f-gutter-10">
            <div class="f-gutter-10__li grid-2">
              <input type="text" name="" v-model="member.addr1" class="input__text" placeholder="입력해주세요" title="주소" readonly>
            </div>
            <div class="f-gutter-10__li grid-2">
              <input type="text" name="" v-model="member.addr2" class="input__text" placeholder="입력해주세요" title="상세주소 입력" v-on:keyup="checked">
            </div>
          </div>
        </div>

        <div class="inline-input-group clearfix">
          <p class="inline-input__label">성별</p>
          <label class="radio-inline label__radio" for="formen">
            <input type="radio" name="inlineRadioOptions" id="formen" v-model="member.gender" value="M" title="남자체크"> 남자
          </label>
          <label class="radio-inline label__radio" for="forwomen">
            <input type="radio" name="inlineRadioOptions" id="forwomen" v-model="member.gender" value="F" title="여자체크"> 여자
          </label>
        </div>

        <div class="inline-input-group clearfix">
          <label for="birthdate" class="inline-input__label">생년월일</label>
          <div class="gutter-10">
            <div class="gutter-10__li grid-3">
              <input type="number" name="" id="birthdate" class="input__text" v-model="birthYear" title="birthdate 입력">
            </div>
            <div class="gutter-10__li grid-3">
              <select class="input__select" v-model="birthMonth" title="월선택">
                <option value="01">1월</option>
                <option value="02">2월</option>
                <option value="03">3월</option>
                <option value="04">4월</option>
                <option value="05">5월</option>
                <option value="06">6월</option>
                <option value="07">7월</option>
                <option value="08">8월</option>
                <option value="09">9월</option>
                <option value="10">10월</option>
                <option value="11">11월</option>
                <option value="12">12월</option>
              </select>
            </div>
            <div class="gutter-10__li grid-3">
              <select class="input__select gutter-10__li grid-3" v-model="birthDay" title="일선택">
                <option value="01">1일</option>
                <option value="02">2일</option>
                <option value="03">3일</option>
                <option value="04">4일</option>
                <option value="05">5일</option>
                <option value="06">6일</option>
                <option value="07">7일</option>
                <option value="08">8일</option>
                <option value="09">9일</option>
                <option value="10">10일</option>
                <option value="11">11일</option>
                <option value="12">12일</option>
                <option value="13">13일</option>
                <option value="14">14일</option>
                <option value="15">15일</option>
                <option value="16">16일</option>
                <option value="17">17일</option>
                <option value="18">18일</option>
                <option value="19">19일</option>
                <option value="20">20일</option>
                <option value="21">21일</option>
                <option value="22">22일</option>
                <option value="23">23일</option>
                <option value="24">24일</option>
                <option value="25">25일</option>
                <option value="26">26일</option>
                <option value="27">27일</option>
                <option value="28">28일</option>
                <option value="29">29일</option>
                <option v-if="birthMonth !== '02'" value="30">30일</option>
                <option v-if="birthMonth !== '02'"  value="31">31일</option>
              </select>
            </div>
          </div>
        </div>
        <div class="inline-input-group clearfix">
          <label class="inline-input__label" for="joinChannel">가입경로</label>
          <select class="input__select" id="joinChannel" v-model="channel"  v-on:change="channelChange" title="joinChannel 선택">
            <option value="서울시 유관홈페이지">서울시 유관홈페이지</option>
            <option value="언론보도">언론보도(신문, 방송, 라디오 등)</option>
            <option value="홍보책자">홍보책자(포스터, 전단지, 리플릿 등)</option>
            <option value="옥외광고">옥외광고(지하철, 버스, 현수막 등)</option>
            <option value="미디어광고">미디어광고(신문잡지, 라디오광고 등)</option>
            <option value="인터넷/SNS 검색">인터넷/SNS 검색(페이스북 등)</option>
            <option value="타 기관 안내">타 기관 안내</option>
            <option value="etc">기타</option>
          </select>
          <input type="text" name="" v-model="channelEtc" id="joinChannelEtc" class="input__text margin-top-10" style="display:none;" v-on:keyup="checked" placeholder="입력해주세요." title="가입경로 기타">
        </div>
        <div class="inline-input-group clearfix">
          <label class="inline-input__label" for="joinMotive">가입동기 및<br/> 희망분야</label>
          <select class="input__select" v-model="motive" id="joinMotive" v-on:change="motiveChange" title="joinMotive 선택">
            <option value="인생후반전 준비에 대한 인식을 가지고자">인생후반전 준비에 대한 인식을 가지고자</option>
            <option value="사회공헌 및 자원봉사에 관심이 있어서">사회공헌 및 자원봉사에 관심이 있어서</option>
            <option value="NGO 등 인생후반전을 위한 단체를 구성하기 위해서">NGO 등 인생후반전을 위한 단체를 구성하기 위해서</option>
            <option value="창업을 위해서">창업을 위해서</option>
            <option value="재취업을 위해서">재취업을 위해서</option>
            <option value="생각이나 취미가 같은 사람들을 만나기 위해">생각이나 취미가 같은 사람들을 만나기 위해</option>
            <option value="etc">기타</option>
          </select>
          <input type="text" name="" v-model="motiveEtc" id="joinMotiveEtc" class="input__text margin-top-10" style="display:none;" v-on:keyup="checked" placeholder="입력해주세요." title="가입동기 기타">
        </div>
        <div class="inline-input-group clearfix">
          <label class="inline-input__label" for="myProfile">사진</label>
          <form name="formmyProfile" id="formmyProfile" method="post" enctype="multipart/form-data" action="/api/file-uploads">
            <input type="file" name="file" class="inline-input__file" id="myProfile" v-on:change="imgUrlChange('myProfile')" title="myProfile 첨부파일 선택">
          </form>
          <img v-if="member.photoUrl" :src="member.photoUrl" alt="프로필 사진" class="file-uploads-thumb">
        </div>
        <div class="inline-input-group clearfix">
          <p class="inline-input__label">나의 관심 50+</p>
          <label class="checkbox-inline label__radio" for="like-orgs">
            <input class="input__checkbox" type="checkbox" v-model="allCheck" name="inlineRadioOptions" id="like-orgs" @click="chkAllOrgs" title="전체 선택"> 전체
          </label>
          <label class="checkbox-inline label__radio" v-for="org in orgList">
            <template  v-if="org.code !== 'fpp'">
              <input class="input__checkbox" v-model="member.likeOrgs" type="checkbox" name="inlineRadioOptions" :value="org.code" :title="org.name"> {{org.name}}
            </template>
          </label>
          <p class="helper-text">* 관심 50+ 기관의 소식(문자, 뉴스레터)을 받을 수 있습니다.</p>
        </div>
        <div class="inline-input-group clearfix">
          <p class="inline-input__label"> 주된 직업군</p>
            <label class="checkbox-inline label__radio" v-for="occu in occuList">
              <input class="input__checkbox" type="checkbox" :value="occu" v-model="member.occuPation" name="occuPationName" :title="occu" @click="onClick(occu)"> {{occu}}
              <span v-if="occu === '기타'">(<input type="text" size="12" maxlength="12" id="occuEtc" v-model="occuEtcVal" v-on:keyup="checked" title="주된 직업군 기타 기입란">)</span>
            </label>
        </div>
        <div class="inline-input-group clearfix">
          <label class="inline-input__label">Email 수신</label>
          <label class="radio-inline label__radio" v-for="(key, value) in emailCheckList">
            <input type="radio" name="inlineRadioOptions1" v-model="emailCheck" :value="value" :title="key"> {{key}}
          </label>
        </div>
        <div class="inline-input-group clearfix">
          <label class="inline-input__label">SMS 수신</label>
          <label class="radio-inline label__radio" v-for="(key, value) in smsCheckList">
            <input type="radio" name="inlineRadioOptions2" v-model="smsCheck" :value="value" :title="key"> {{key}}
          </label>
        </div>
        <div class="form-submit-gruop">
          <button type="button" class="form-submit__btn btn--blue-line" @click="updateInfo">다음</button>
        </div>
      </div>
    </div>

    <div v-if="step === 2">
      <div class="basic-form">
        <h2 class="basic-form-title">2. 강좌정보</h2>
        <div class="block-input-group clearfix">
          <label class="block-input-label" for="applicant-motive" title="신청하게 된 동기를 간단하게 작성해 주세요.">위 과정을 신청하게 된 동기를 간단하게 작성해 주세요.</label>
          <textarea rows="4" ref="motive" id="applicant-motive" class="input__textarea" v-model.trim="application.motive" placeholder="최대 1000자까지 작성하실 수 있습니다." title="최대 1000자까지 작성하실 수 있습니다."></textarea>
        </div>

        <div v-for="(item, index) in forms" class="block-input-group clearfix">
          <label class="block-input-label" title="강좌 신청서 질문">{{item.question}}</label>
          <input v-if="item.type === 'SHORT'" type="text" class="input__text" v-model.trim="answers[index]" :title="item.question"/>
          <textarea v-if="item.type === 'ESSAY'" class="input__textarea" rows="4"
                    v-model.trim="answers[index]" placeholder="최대 1000자까지 작성하실 수 있습니다." :title="item.question"></textarea>
          <template v-if="item.type === 'SINGLE'">
            <label v-for="choice in item.choices" class="radio-inline label__radio" :title="choice">
              <input type="radio" :value="choice" v-model="answers[index]" :title="choice">{{choice}}
            </label>
          </template>
          <template v-if="item.type === 'MULTI'">
            <label v-for="choice in item.choices" class="checkbox-inline label__radio" :title="choice">
              <input class="input__checkbox" type="checkbox" :value="choice" v-model="answers[index]" title="choice">{{choice}}
            </label>
          </template>
        </div>

        <div class="form-submit-gruop">
          <button type="button" class="form-submit__btn line-btn--red" @click="goToPrevious">이전</button>
          <button type="button" class="form-submit__btn btn--blue-line" @click="goToStep3">다음</button>
        </div>
      </div>
    </div>

    <div v-if="step === 3">
      <div class="basic-form">
        <h2 class="basic-form-title">3. 등록</h2>
        <div class="block-input-group clearfix" v-if="(lecture.type === 'CHARGED' || lecture.type === 'CHARGED_CONFIRM') && lecture.lctOrgSe !== 'CAMPUS'">
          <label class="block-input-label" style="font-size: 18px;">감면/면제 신청
            <span class="block-input-label__helper">* 해당하는 경우에만 체크하세요.</span>
          </label>
          <label class="radio-inline label__radio" for="discount1">
            <input type="radio" value="" id="discount1" v-model="discount" title="해당사항 없음" checked> 해당사항 없음
          </label>
          <label class="radio-inline label__radio" for="discount2">
            <input type="radio" value="국가유공자" id="discount2" v-model="discount" title="국가유공자">국가유공자
          </label>
          <label class="radio-inline label__radio" for="discount3">
            <input type="radio" value="기초생활수급자" id="discount3" v-model="discount" title="기초생활수급자">기초생활수급자
          </label>
          <label class="radio-inline label__radio" for="discount4">
            <input type="radio" value="장애인복지법에 따른 장애인" id="discount4" v-model="discount" title="장애인복지법에 따른 장애인">장애인복지법에 따른 장애인
          </label>
          <label class="radio-inline label__radio" for="discount5" v-if="lecture.lctOrgCd !== 'ydp'">
            <input type="radio" value="고용보험법에 따른 실업급여수급자" id="discount5" v-model="discount" title="고용보험법에 따른 실업급여수급자">고용보험법에 따른 실업급여수급자
          </label>
          <label class="radio-inline label__radio" for="discount6" v-if="lecture.lctOrgSe !== 'CAMPUS' && lecture.lctOrgCd !== 'sdc' && lecture.lctOrgCd !== 'ydp' && lecture.lctOrgCd !== 'sch'">
            <input type="radio" value="북한이탈주민" id="discount6" v-model="discount" title="북한이탈주민">북한이탈주민
          </label>
          <label class="radio-inline label__radio" for="discount7" v-if="lecture.lctOrgSe !== 'CAMPUS' && lecture.lctOrgCd !== 'sdc' && lecture.lctOrgCd !== 'ydp' && lecture.lctOrgCd !== 'sch'">
            <input type="radio" value="한부모가족" id="discount7" v-model="discount" title="한부모가족">한부모가족
          </label>
          <div class="text-area-box" tabIndex="0">
            <h4 class="text-area-box__section-title" style="margin-top: 0; font-size: 15px;" >※ 각 기관별 더 자세한 감면/면제 안내 사항은 해당 기관의 홈페이지를 확인하여 주시기 바랍니다.</h4>
            <br>
            <h4 class="text-area-box__section-title campus" style="margin-top: 0; color: #C84664;" >캠퍼스 및 도심권사업팀</h4>
            <p class="area-box__middle-section">※근거</p>
            <ul>
              <li>「서울특별시 장년층 인생이모작지원에 관한 조례(2017.1.5.)」</li>
            </ul>
            <p class="area-box__middle-section">면제 안내 및 절차</p>
            <ul>
              <li>• 수강료 면제 대상자(세부 기준은 하단 참조)는 강좌 신청 후 반드시 수강료 전액을 납부</li>
              <li>• 분기별 1개 교육과정의 수강료 면제 가능(연 4개 이하 교육과정 수강료 면제 가능)</li>
              <li>&nbsp;&nbsp;&nbsp;※ 외부기관 협력(연계 유료 교육과정 포함)</li>
              <li>• 강좌 종료 후 수료한 분들에 한하여, 상담센터에서 증빙서류를 확인 후 환불처리 진행</li>
              <li>• 유료강좌를 수료한 면제 대상자는 종강 후, 1주일 이내에 증빙서류를 제출 (※ 수료기준: 70%이상 출석)</li>
            </ul>
            <p class="area-box__middle-section">면제 대상</p>
            <ul>
              <li>(주민등록상 서울시 거주자에 한함)</li>
              <li>• 「국민기초생활보장법」에 의한 수급자</li>
              <li>• 「국가유공자 등 예우에 관한 법률」 제 4조에 의한 국가유공자와 그 가족</li>
              <li>• 「장애인 복지법」에 따른 등록 장애인</li>
              <li>• 「고용보험법」에 따른 실업급여 수급자</li>
            </ul>
            <p class="area-box__middle-section">구비 서류</p>
            <ul>
              <li>(모든 서류는 3개월 이내 발급된 것이어야 함)</li>
              <li>•(공통) 학습비 면제신청서 1부, 주민등록등본(주소지 확인용)</li>
              <li>•국민기초생활수급자 증명서</li>
              <li>•국가 유공자(유족) 확인서(신청인에 신청자 본인 명기 必), 국가유공자증, 국가유공자 유족증(택1)</li>
              <li>•장애인 증명서(등록증), 복지카드 사본(택1)</li>
              <li>•고용보험수급자격증(실업자 수급 수첩) 사본</li>
            </ul>
            <h4 class="text-area-box__section-title center" style="color: #1E8732;">동작50플러스센터</h4>
            <p class="area-box__middle-section">※근거</p>
            <ul>
              <li>「평생교육법 시행령(제23조제2항) 학습비 반환기준 및 소비자분쟁해결기준</li>
            </ul>
            <p class="area-box__middle-section">면제 안내 및 절차</p>
            <ul>
              <li>홈페이지 프로그램 신청 후, 수강료 선 납부 /</li>
              <li>결제 완료 후 증빙서류 지참, 센터 방문시 담당자에 제출 / 환급처리</li>
            </ul>
            <p class="area-box__middle-section">면제 대상</p>
            <ul>
              <li>• 「국민기초생활보장법」에 의한 수급자</li>
              <li>• 「국가유공자 등 예우에 관한 법률」 제 4조에 의한 국가유공자 본인 (100% 환급)과  그 직계가족 (50% 환급)</li>
              <li>• 「장애인 복지법」에 따른 등록 장애인</li>
            </ul>
            <p class="area-box__middle-section">구비 서류</p>
            <ul>
              <li>1. (공통) 신분증 사본 1부</li>
              <li>2. (해당자) 수급자 확인서, 유공자 확인서, 복지카드 사본1부</li>
              <li>3. (해당자) 가족관계증명서 1부</li>
              <li>4. (해당자) 환불계좌 통장사본 1부 (무통장입금자)</li>
              <li>5. 카드결제자는 카드 취소</li>
            </ul>
            <h4 class="text-area-box__section-title center" style="color: #1E8732;">노원50플러스센터</h4>
            <p class="area-box__middle-section">※근거</p>
            <ul>
              <li>「서울특별시 노원구 장년층 인생이모작 지원에 관한 조례(2017.3.16.)」</li>
            </ul>
            <p class="area-box__middle-section">면제 안내 및 절차</p>
            <ul>
              <li>• 수강료 면제 대상자는 강좌 신청 후 반드시 수강료 전액을 납부</li>
              <li>• 면제 횟수는 연간 1인 2회까지(교육시작일 기준) </li>
              <li>• 강좌를 수료한 면제대상자는 종강일 기준 7일전~종강일까지 증빙서류 제출(2층사무실)</li>
              <li>&nbsp;&nbsp;&nbsp;(수료생기준:70%이상 출석자)</li>
              <li>• 감면 대상 서류 제출일 기준 2주이내 환불처리</li>
            </ul>
            <p class="area-box__middle-section">면제 대상</p>
            <ul>
              <li>• 「국민기초생활보장법」에 의한 수급자</li>
              <li>• 「국가유공자 등 예우에 관한 법률」 제 4조에 의한 국가유공자와 그 가족</li>
              <li>• 「장애인 복지법」에 따른 등록 장애인</li>
            </ul>
            <p class="area-box__middle-section">구비 서류</p>
            <ul>
              <li>• (공통) 신분증 사본 1부, 환불계좌 통장사본 1부</li>
              <li>• (해당자) </li>
              <li>&nbsp;&nbsp;&nbsp;- 국민기초생활수급자 증명서</li>
              <li>&nbsp;&nbsp;&nbsp;- 국가유공자 확인서(국가유공자 가족 : 가족관계증명서) 또는 국가유공자증, 국가유공자유족증</li>
              <li>&nbsp;&nbsp;&nbsp;- 장애인증명서(등록증) 또는 복지카드 사본</li>
            </ul>
            <h4 class="text-area-box__section-title center" style="color: #1E8732;">서대문50플러스센터</h4>
            <p class="area-box__middle-section">※근거</p>
            <ul>
              <li>「서울특별시 서대문구 장년층 인생이모작 지원에 관한 조례」 (2019.7.10.)」</li>
            </ul>
            <p class="area-box__middle-section">면제 안내 및 절차</p>
            <ul>
              <li>수강료 면제 기준에 해당되어도 먼저 수강료를 납부해야 합니다.</li>
              <li>수업을 이수한 뒤, 면제 신청서를 작성하시면 2주 내에 환급 처리됩니다.</li>
              <li>*이수증은 70%이상 출석 시 발급됩니다.</li>
              <li>*수강료 면제는 연 1회만 가능합니다.</li>
              <li>* 수강료 결제방법에 따라 카드결제 취소 혹은 결제(지정)계좌로 환불 진행됩니다.</li>
              <li>※ 유의사항 : 수강료는 면제이나 ‘재료비 및 교재비’는 면제 불가</li>
            </ul>
            <p class="area-box__middle-section">면제 대상</p>
            <ul>
              <li>• 「국민기초생활보장법」에 의한 수급자</li>
              <li>• 「국가유공자 등 예우에 관한 법률」에 따른 국가유공자와 그 가족</li>
              <li>• 「장애인복지법」에 따라 장애인으로 등록된 자</li>
              <li>• 「고용보험법」에 따른 실업급여 수급자</li>
            </ul>
            <p class="area-box__middle-section">구비 서류</p>
            <ul>
              <li>1. (공통) 수강료 면제 신청서 1부</li>
              <li>2. (공통) 신분증 사본 및 통장사본 1부</li>
              <li>3. (해당자) 국민기초생활수급자 증명서</li>
              <li>4. (해당자) 국가 유공자(유족) 확인서</li>
              <li>5. (해당자) 장애인 증명서(등록증) 또는 복지카드 사본</li>
              <li>6. (해당자) 고용보험수급자격증(실업자 수급 수첩) 사본</li>
              <li>※모든 서류는 3개월이내 발급된 것이어야 함</li>
            </ul>
            <h4 class="text-area-box__section-title center" style="color: #1E8732;">성북50플러스센터</h4>
            <p class="area-box__middle-section">※근거</p>
            <ul>
              <li>「서울특별시 장년층 인생이모작지원에 관한 조례(2017.1.5.)」</li>
            </ul>
            <p class="area-box__middle-section">면제 안내 및 절차</p>
            <ul>
              <li>• 본인이 센터에 방문하여 접수, 신청서 및 '구비서류' 제출 필수 (홈페이지 접수 및 전화접수 불가능)</li>
              <li>• 면제대상자 1인에 연간 2회까지 면제</li>
              <li>• 면제대상자도 유료강좌 수강신청 후 반드시 수강료 결제 진행해야 하며, '수료자에 한해서만' 환급</li>
              <li>• 환급시기: 강좌 종료 후 1주 이내</li>
            </ul>
            <p class="area-box__middle-section">면제 대상</p>
            <ul>
              <li>• 「국민기초생활 보장법」에 의한 수급자</li>
              <li>• 「국가유공자 등 예우 및 지원에 관한 법률」에 의한 국가유공자와 그 가족</li>
              <li>• 「장애인복지법」에 따라 장애인으로 등록된 자</li>
              <li>• 「고용보험법」에 따른 실업급여 수급자</li>
              <li>&nbsp;&nbsp;&nbsp;※ 유의사항: 수강료는 면제이나 '재료비 및 교재비는 별도' 부담</li>
            </ul>
            <p class="area-box__middle-section">구비 서류</p>
            <ul>
              <li>• (공통) 수강료 면제 신청서 - 센터 방문하여 작성</li>
              <li>• (공통) 신분증 사본</li>
              <li>• (해당자) 국민기초생활수급자 증명서</li>
              <li>• (해당자) 국가유공자/유족 확인서 - 신청인에 신청자 본인 명기 필수</li>
              <li>• (해당자) 장애인 증명서 또는 복지카드 사본</li>
              <li>• (해당자) 고용보험수급자격증 카드/실업자 수급수첩 사본</li>
              <li>&nbsp;&nbsp;&nbsp;※ 유의사항: 모든 서류는 3개월 이내 발급된 것이어야 함.</li>
            </ul>
            <h4 class="text-area-box__section-title center" style="color: #1E8732;">금천50플러스센터</h4>
            <p class="area-box__middle-section">※근거</p>
            <ul>
              <li>「서울특별시 장년층 인생이모작지원에 관한 조례 제6조의4(사용료의 감면 등)」</li>
            </ul>
            <p class="area-box__middle-section">면제 안내 및 절차</p>
            <ul>
              <li>• 방문접수를 필수로 하며 온라인 및 전화접수는 불가능 하다.</li>
              <li>• 수강료 면제 대상자(세부 기준은 하단 참조)는 강좌 신청 후 반드시 수강료 전액을 납부</li>
              <li>• 연간 2개 교육과정의 수강료 면제가 가능, 면제 대상자는 강좌별 정원의 20%룰 초과할 수 없음</li>
              <li>• 강좌 종료 후 수료한 분들에 한하여, 금천50플러스센터에서 증빙서류를 확인 후 환불처리 진행</li>
              <li>• 유료강좌를 수료한 면제 대상자는 종강 후, 1주일 이내에 증빙서류를 제출 (※ 수료기준: 70%이상 출석)</li>
            </ul>
            <p class="area-box__middle-section">면제 대상</p>
            <ul>
              <li>•「국민기초생활보장법」에 의한 수급자</li>
              <li>•「국가유공자 등 예우에 관한 법률」에 의한 국가유공자와 그 가족</li>
              <li>•「장애인 복지법」에 따라 장애인으로 등록된 자</li>
              <li>•「고용보험법」에 따른 실업급여 수급자</li>
            </ul>
            <p class="area-box__middle-section">구비 서류</p>
            <ul>
              <li>(공통) 수강료 면제 신청서</li>
              <li>• 국민기초생활수급자증명서</li>
              <li>• 국가유공자(유족)확인서(신청인에 신청자 본인 명기 必)</li>
              <li>• 가족관계증명서(해당자)</li>
              <li>• 장애인등록증(복지카드 사본)</li>
              <li>• 고용보험수급자격카드(실업자 수급 수첩)</li>
              <li>※ 모든 서류는 신청일 기준 3개월 이내 발급된 것이어야 함.</li>
            </ul>
            <h4 class="text-area-box__section-title center" style="color: #1E8732;">강서50플러스센터</h4>
            <p class="area-box__middle-section">※근거</p>
            <ul>
              <li>「서울특별시 강서구 중·장년층 인생이모작 지원에 관한 조례 시행규칙(2021.6.16.)」</li>
            </ul>
            <p class="area-box__middle-section">면제 안내 및 절차</p>
            <ul>
              <li>• 아래 '면제 신청방법 구비서류' 를 가지고 본인이 센터에 방문하여 접수.</li>
              <li>• 면제대상자(본인) 연간 2회까지 면제 </li>
              <li>• 면제대상자도 유료강좌 수강신청 후 반드시 수강료 결제 진행해야 하며, '이수자에 한해서만' 환급</li>
              <li>&nbsp;&nbsp;&nbsp;※ 이수자(수료자) : 신청한 강좌의 70%이상 출석 시 인정.</li>
              <li>• 환불시기 : 강좌 종료 후 2주 이내.</li>
            </ul>
            <p class="area-box__middle-section">면제 대상</p>
            <ul>
              <li>• 「국민기초생활 보장법」에 의한 수급자 </li>
              <li>• 「국가유공자 등 예우 및 지원에 관한 법률」에 의한 국가유공자와 그 직계가족</li>
              <li>• 「장애인복지법」에 따라 장애인으로 등록된 자</li>
              <li>• 「고용보험법」에 따른 실업급여 수급자</li>
              <li>&nbsp;&nbsp;&nbsp;※ 교육 개강일 기준 면제대상 시 적용.</li>
              <li>&nbsp;※ 재료비 및 교재비는 면제대상에 해당되지 않음.(본인 별도부담)</li>
            </ul>
            <p class="area-box__middle-section">구비 서류</p>
            <ul>
              <li>• (공통) 수강료 면제(감면) 신청서</li>
              <li>• (공통) 신분증 사본 1부 </li>
              <li>• (공통) 본인 명의의 환불계좌 통장 사본 1부</li>
              <li>• (해당자) 국민기초생활수급자 증명서</li>
              <li>• (해당자) 국가유공자/유족 확인서</li>
              <li>• (해당자) 장애인 증명서 또는 복지카드 사본</li>
              <li>• (해당자) 고용보험수급자격증 카드/실업자 수급수첩 사본</li>
              <li>&nbsp;※ 모든 서류는 3개월 이내 발급된 것이어야 함.</li>
            </ul>
            <h4 class="text-area-box__section-title center" style="color: #1E8732;">서초50플러스센터</h4>
            <p class="area-box__middle-section">※근거</p>
            <ul>
              <li>「서울특별시 서초구 장년층 인생이모작 지원에 관한 조례[시행2020.2.6.]</li>
              <li>제 8조(사용료의 감면)에 의한 규정 사안」</li>
            </ul>
            <p class="area-box__middle-section">면제 안내 및 절차</p>
            <ul>
              <li>• 수강료 면제 대상자(세부 기준은 하단 참조)는 강좌 신청 후 반드시 수강료 전액을 납부</li>
              <li>• 수강신청시 면제 대상자 해당 체크란에 사전 체크한 분들에 한하여 면제 가능 </li>
              <li>• 연 2회 교육과정의 수강료 면제가 가능</li>
              <li>• 강좌 종료 후 수료한 분들에 한하여, 증빙서류를 확인 후 환불처리 진행</li>
              <li>• 유료강좌를 수료한 면제 대상자는 종강 후, 1주일 이내에 증빙서류를 제출 (※ 수료기준: 80%이상 출석)</li>
              <li>• 증빙서류 제출 시 방문접수 필수</li>
              <li>• 수강료 면제시 교재비, 재료비는 면제되지 않음</li>
            </ul>
            <p class="area-box__middle-section">면제 대상</p>
            <ul>
              <li>• 「국민기초생활보장법」에 의한 수급자</li>
              <li>• 「국가유공자 등 예우에 관한 법률」 제 4조에 의한 국가유공자와 그 가족</li>
              <li>• 「장애인 복지법」에 따른 등록 장애인</li>
              <li>• 「고용보험법」에 따른 실업급여 수급자</li>
            </ul>
            <p class="area-box__middle-section">구비 서류</p>
            <ul>
              <li>(공통) 수강료 면제신청서 1부, 신분증 사본 또는 주민등록등본(주소지 확인용),</li>
              <li>&nbsp;&nbsp;&nbsp;환불계좌 통장사본 1부, 해당 강좌 이수증 1부.</li>
              <li>(해당자) 국민기초생활수급자 증명서</li>
              <li>&nbsp;&nbsp;&nbsp;국가 유공자(유족) 확인서(신청인에 신청자 본인 명기 必),</li>
              <li>&nbsp;&nbsp;&nbsp;국가유공자증, 국가유공자 유족증(택1)</li>
              <li>&nbsp;&nbsp;&nbsp;장애인 증명서(등록증), 복지카드 사본(택1)</li>
              <li>&nbsp;&nbsp;&nbsp;고용보험수급자격증(실업자 수급 수첩) 사본</li>
            </ul>
            <h4 class="text-area-box__section-title center" style="color: #1E8732;">강동50플러스센터</h4>
            <p class="area-box__middle-section">※근거</p>
            <ul>
              <li>「서울특별시 장년층 인생이모작지원에 관한 조례(2021.5.26.) 제9조(사용료 등)」</li>
            </ul>
            <p class="area-box__middle-section">면제 안내 및 절차</p>
            <ul>
              <li>• 수강료 면제 대상자는 최종 승인완료 문자를 받은 후, 결제기일 내에 증빙 서류를 제출하면</li>
              <li>&nbsp;&nbsp;&nbsp;수강료 면제(전액 납부 후 환불 처리 지양)</li>
              <li>• 수강료 감면 대상자(한부모가족)는 서류 접수 후 50%범위 이내 환불 처리</li>
              <li>• 최대 연 2회 면제/감면이 가능하여 강좌별 승인 문자를 받은 후, </li>
              <li>&nbsp;&nbsp;&nbsp;감면/전액 결제하는 방법 중 수강 대상자가 선택</li>
              <li>• 교재비와 재료비는 개강 후 강사에게 별도 납부하며, 감면/면제 불가</li>
            </ul>
            <p class="area-box__middle-section">면제 대상</p>
            <table>
              <caption>수강료 면제·감면기준 표</caption>
              <colgroup>
                <col width="20%"/>
                <col width="40%"/>
                <col width="40%"/>
              </colgroup>
              <thead>
                <tr>
                  <th scope="col" style="background: #006ffb !important;">구분</th>
                  <th scope="col" style="background: #006ffb !important;">대상</th>
                  <th scope="col" style="background: #006ffb !important;">증빙서류</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td rowspan="6">면제</td>
                  <td>국가유공자와 그 유족 또는 가족</td>
                  <td>국가유공자 확인서, 국가 유공자증.<br>국가유공자 유족증(택1)</td>
                </tr>
                <tr>
                  <td>국민기초생활 수급자</td>
                  <td>국민기초생활 수급자 증명서</td>
                </tr>
                <tr>
                  <td>등록장애인</td>
                  <td>장애인 증명서(등록증),<br>복지카드사본(택1)</td>
                </tr>
                <tr>
                  <td>고용보험 수급자격 인정자</td>
                  <td>고용보험 수급자격증<br>(실업자 수급급여 수첩) 사본</td>
                </tr>
                <tr>
                  <td>북한이탈주민 보호대상자</td>
                  <td>북한이탈주민 등록확인서</td>
                </tr>
                <tr>
                  <td>그 밖에 사용료 감면이 필요하다고<br>구청장이 인정하는 사람</td>
                  <td></td>
                </tr>
                <tr>
                  <td>50% 범위<br>이내 감면</td>
                  <td>한부모가족</td>
                  <td>한부모가족증명서</td>
                </tr>
              </tbody>
            </table>
            <p class="area-box__middle-section">구비 서류</p>
            <ul>
              <li>• 아래 2가지 서류를 온라인으로 제출(수신 이메일: gdc@50center.or.kr)</li>
              <li>&nbsp;&nbsp;1) 수강료 면제 신청서 1부</li>
              <li>&nbsp;&nbsp;2) 증빙서류(해당하는 감면 사유에 맞는 증빙 서류, 위의 표 참고)</li>
              <li>&nbsp;&nbsp;※ 모든 서류는 신청일 기준 3개월 이내 발급된 것이어야 함</li>
            </ul>
            <h4 class="text-area-box__section-title center" style="color: #1E8732;">양천50플러스센터</h4>
            <p class="area-box__middle-section">※근거</p>
            <ul>
              <li>「서울특별시 장년층 인생이모작지원에 관한 조례(2017.1.5.)」</li>
            </ul>
            <p class="area-box__middle-section">면제 안내 및 절차</p>
            <ul>
              <li>• 수강료 면제 대상자(세부 기준은 하단 참조)는 강좌 신청 후 반드시 수강료 전액을 납부</li>
              <li>• 반기별 1개 교육과정의 수강료 면제가 가능(연 2개 이하 교육과정 수강료 면제 가능)</li>
              <li>&nbsp;&nbsp;※ 면제는 교육정원의 10%로 제한(신청자가 다수일 경우, 선착순 결제완료자 우선 선정)</li>
              <li>• 강좌 종료 후 수료한 분들에 한하여, 상담센터에서 증빙서류를 확인 후 환불처리 진행</li>
              <li>• 유료강좌를 수료한 면제 대상자는 종강 후, 1주일 이내에 증빙서류를 제출 (※ 수료기준: 70%이상 출석)</li>
            </ul>
            <p class="area-box__middle-section">면제 대상</p>
            <ul>
              <li>• 「국민기초생활보장법」에 의한 수급자</li>
              <li>• 「국가유공자 등 예우에 관한 법률」 제 4조에 의한 국가유공자 본인</li>
              <li>• 「장애인 복지법」에 따른 등록 장애인</li>
              <li>• 「고용보험법」에 따른 실업급여 수급자(수급자격인정일자가 교육시작일 이전)</li>
              <li>• 「북한이탈주민의 보호 및 정착지원에 관한 법률」에 따른 보호대상자</li>
            </ul>
            <p class="area-box__middle-section">구비 서류</p>
            <ul>
              <li>(공통) 학습비 면제신청서 1부, 주민등록등본(주소지 확인용)</li>
              <li>&nbsp;&nbsp;&nbsp;국민기초생활수급자 증명서</li>
              <li>&nbsp;&nbsp;&nbsp;국가 유공자 확인서(신청인에 신청자 본인 명기 必), 국가유공자증(확인서)</li>
              <li>&nbsp;&nbsp;&nbsp;장애인 증명서(등록증), 복지카드 사본(택1)</li>
              <li>&nbsp;&nbsp;&nbsp;고용보험수급자격증(실업자 수급 수첩) 사본</li>
              <li>&nbsp;&nbsp;&nbsp;북한이탈주민 등록확인서</li>
            </ul>
            <h4 class="text-area-box__section-title center" style="color: #1E8732;">성동50플러스센터</h4>
            <p class="area-box__middle-section">※근거</p>
            <ul>
              <li>「서울특별시 성동구 장년층 인생이모작 지원에 관한 조례(시행 2021.3.15.)」</li>
            </ul>
            <p class="area-box__middle-section">면제 안내 및 절차</p>
            <ul>
              <li>• ‘면제 신청 강좌 개강일’ 기준 면제 자격 유지 대상자 중 해당 강좌 이수자(이수기준 : 70%이상 출석)</li>
              <li>• 연 2회까지 가능</li>
              <li>• ‘면제 신청 구비서류’ 지참하여 운영지원팀 사무실 내방, 신청서 작성 후 접수</li>
              <li>• 면제 신청강좌 종강일까지 개별 접수 진행</li>
              <li>• 강좌 종강 이후 2주 이내 처리</li>
            </ul>
            <p class="area-box__middle-section">면제 대상</p>
            <ul>
              <li>• 국민기초생활보장법」에 의한 수급자</li>
              <li>• 「국가유공자 등 예우에 관한 법률」 제 4조에 의한 국가유공자와 그 가족</li>
              <li>• 「장애인 복지법」에 따른 등록 장애인</li>
              <li>• 「고용보험법」에 따른 실업급여 수급자</li>
            </ul>
            <p class="area-box__middle-section">구비 서류</p>
            <ul>
              <li>• (공통)신분증 사본 1부 </li>
              <li>• (공통)본인 명의의 환불계좌 통장 사본 1부(계좌이체로 입금한 경우)</li>
              <li>• (해당자) 국민기초생활수급자 증명서</li>
              <li>• (해당자) 국가유공자/유족 확인서</li>
              <li>• (해당자) 장애인 증명서 또는 복지카드 사본</li>
              <li>• (해당자) 고용보험수급자격증 카드/실업자 수급수첩 사본</li>
            </ul>
            <h4 class="text-area-box__section-title center" style="color: #1E8732;">강북50플러스센터</h4>
            <p class="area-box__middle-section">※근거</p>
            <ul>
              <li>「평생교육법 시행령(제23조제2항) 학습비 반환기준 및 소비자분쟁해결기준」</li>
            </ul>
            <p class="area-box__middle-section">면제 안내 및 절차</p>
            <ul>
              <li>- 수강신청 → 결제 → 강좌 수강 및 이수 → 면제신청</li>
              <li>&nbsp;&nbsp;※ 면제 대상자 체크  ※ 출석율 70% 이상 ※ 면제신청서 작성 및 구비서류 준비 후 신청</li>
              <li>- 수강신청 시 반드시 ‘면제 대상자’를 체크하셔야 수강료 면제 대상자가 됩니다.</li>
              <li>&nbsp;&nbsp;※ 수급자격 인정일자가 교육시작일 이전이어야 합니다.</li>
              <li>예) 면제대상 O : 교육시작(2/1~), 수급자격 인정(1/31~)</li>
              <li>&nbsp;&nbsp;&nbsp;면제대상 X : 교육시작(2/1~), 수급자격 인정(2/2~)</li>
            </ul>
            <p class="area-box__middle-section">면제 대상</p>
            <ul>
              <li>• 「국민기초생활보장법」에 의한 수급자 : 국민기초 생활 수급자 증명서</li>
              <li>• 「국가유공자 등 예우에 관한 법률」 제 4조에 의한 국가유공자와 그 가족: 국가 유공자 확인서</li>
              <li>• 「장애인 복지법」에 따른 등록 장애인: 장애인 증명서 또는 복지카드</li>
              <li>• 「고용보험법」에 따른 실업급여 수급자: 고용보험수급자격증(실업자 수급 수첩) 사본</li>
              <li>• 「북한이탈주민의 보호 및 정착지원」에 따른 보호대상자: 북한이탈주민 등록확인서</li>
              <li>- 그 밖에 수강료 감면이 필요하다고 구청장이 인정하는 사람</li>
              <li>- 모든 서류는 3개월 이내 발급된 것이어야 함</li>
            </ul>
            <p class="area-box__middle-section">구비 서류</p>
            <ul>
              <li>- 개인당 연2회 수강료 면제 가능(상반기, 하반기 각 1회)</li>
              <li>- 강좌당 정원의 30%로 제한(다수의 신청자가 있을 경우 선착순 결제 완료자를 원칙 선정함)</li>
              <li>- 종강 후 2주 이내 면제 신청서 제출(2주 이내 수강료 환불 예정)</li>
              <li>- 면제 대상자도 수강료 선결제 이후 강좌를 이수한자에 한해 수강료 면제</li>
              <li>- 이수 확인 후, 구비서류(면제신청서, 이수증, 구비서류, 신분증, 통장사본 등) 방문</li>
              <li>&nbsp;&nbsp;또는 이메일(gb50plus@naver.com) 제출</li>
              <li>- 재료비 및 교재비는 면제 불가</li>
            </ul>
            <p class="area-box__middle-section">수강료 면제 제출 서류</p>
            <ul>
              <li>-(공통) 면제 신청서, 강좌이수증, 신분증, 통장사본 각 2부.</li>
              <li>-(해당자) 수강료 면제대상자를 확인할 수 있는 증빙서류(3개월 이내 발급)</li>
            </ul>
          </div>
        </div>
        
        <div class="block-input-group clearfix" v-if="lecture.type === 'CHARGED' || lecture.type === 'CHARGED_CONFIRM'">
          <label class="block-input-label" style="font-size: 18px;">환불안내</label>
          <div class="text-area-box" tabIndex="0">
            <h4 class="text-area-box__section-title" style="margin-top: 0; font-size: 15px;" >※ 각 기관별 더 자세한 환불 안내 사항은 해당 기관의 홈페이지를 확인하여 주시기 바랍니다.</h4>
            <br>
            <h4 class="text-area-box__section-title campus" style="margin-top: 0; color: #C84664;" >캠퍼스 및 도심권사업팀</h4>
            <p class="area-box__middle-section">※근거</p>
            <ul>
              <li>「평생교육법 시행령(제23조제2항) 학습비 반환기준 및 소비자분쟁해결기준」</li>
            </ul>
            <p class="area-box__middle-section">1. 신청 방법</p>
            <ul>
              <li>•홈페이지 로그인 ⇒ 마이페이지 內 수강확인 및 취소 ⇒ 환불 처리(신청일로부터 2주 이내, 본인 명의 계좌로 환급)</li>
            </ul>
            <p class="area-box__middle-section">2. 환불 기준</p>
            <ul>
              <li>•개강일 이전은 전액 환급되며, 개강일 이후는 남은 기간을 산정하여 수강료 환급</li>
            </ul>
            <table>
              <caption>환불기준 표</caption>
              <colgroup>
                <col width="20%"/>
                <col width="40%"/>
                <col width="40%"/>
              </colgroup>
              <thead>
                <tr>
                  <th scope="col" style="background: #006ffb !important;">구분</th>
                  <th scope="col" style="background: #006ffb !important;">반환사유 발생일</th>
                  <th scope="col" style="background: #006ffb !important;">반환금액</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td rowspan="4">학습비 징수기간이<br>1개월 이내인 경우</td>
                  <td>수업시작 전</td>
                  <td>이미 낸 학습비 전액</td>
                </tr>
                <tr>
                  <td>총 수업시간의 1/3 경과 전</td>
                  <td>이미 낸 학습비의 2/3 해당 금액</td>
                </tr>
                <tr>
                  <td>총 수업시간의 1/2 경과 전 </td>
                  <td>이미 낸 학습비의 1/2 해당 금액</td>
                </tr>
                <tr>
                  <td>총 수업시간의 1/2 경과 후</td>
                  <td>반환하지 아니함</td>
                </tr>
                <tr>
                  <td rowspan="2">학습비 징수기간이<br>1개월을 초과하는 경우</td>
                  <td>수업시작 전</td>
                  <td>이미 낸 학습비 전액</td>
                </tr>
                <tr>
                  <td>수업시작 후</td>
                  <td>환불요청일 당해 월의 반환 학습비(학습비 징수기간이 1개월 이내인 경우에 준하여 산출된 학습비를 말한다)와 나버지 잔여달(잔여회차)의 학습비 전액을 합산한 금액</td>
                </tr>
                <tr>
                  <td>1일 특강 및 단기 특강</td>
                  <td colspan="2">개강일 이전까지만 전액 환불 가능</td>
                </tr>
                <tr>
                  <td>비고</td>
                  <td colspan="2" style="text-align: left;">1. ‘학습비 징수기간’이란 징수된 총학습비에 따른 총 수업일을 말한다.
<br><br>※ 징수기간에서 1개월이란 「평생교육시설 관련 학습비 반환기준 해석지침」에 의거 강의 시작일로부터 적용
2. ‘총 수업시간’이란 학습비 징수기간 중의 총 수업시간(회차)을 말한다.
<br>※ 반환금액의 산정은 반환사유가 발생한 날까지 경과된 수업시간을 기준으로, 학습 포기 의사를 
<br>&nbsp;밝힌 날의 다음날부터 계산하여 반환함
<br>※ 환불시 10원 미만은 절사함</td>
                </tr>
              </tbody>
            </table>
            <p class="area-box__middle-section">3. 유의 사항</p>
            <ul>
              <li>•개강 후 재료비는 환불 불가</li>
              <li>•개강 중 중간신청자도 강좌개강일 시점으로 동일한 환불기준이 적용됨</li>
              <li>•신용카드 결제 신청자의 개강 후 환불은 무통장 입금(계좌이체)으로 환불</li>
              <li>- 개강 전 취소는 100% 환불(카드 취소)</li>
              <li>- 개강 후 일부 환불은 환불 신청자 명의 계좌로 무통장 입금</li>
            </ul>
            <h4 class="text-area-box__section-title center" style="color: #1E8732;">동작50플러스센터</h4>
            <p class="area-box__middle-section">※근거</p>
            <ul>
              <li>「평생교육법 시행령(제23조제2항) 학습비 반환기준 및 소비자분쟁해결기준</li>
            </ul>
            <p class="area-box__middle-section">1. 신청 방법</p>
            <ul>
              <li>•홈페이지 로그인 ⇒ 마이페이지 內 수강확인 및 취소 ⇒ 환불 처리(신청일로부터 2주 이내, 본인 명의 계좌로 환급)</li>
            </ul>
            <p class="area-box__middle-section">2. 환불 기준</p>
            <ul>
              <li>•개강 1일전 전액 환급되며, 개강일 이후는 남은 기간을 산정하여 수강료가 환급</li>
            </ul>
            <table>
              <caption>환불기준 표</caption>
              <colgroup>
                <col width="30%"/>
                <col width="40%"/>
                <col width="30%"/>
              </colgroup>
              <thead>
                <tr>
                  <th scope="col" style="background: #006ffb !important;">반환사유 발생일</th>
                  <th scope="col" style="background: #006ffb !important;">반환금액</th>
                  <th scope="col" style="background: #006ffb !important;">비고</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>강좌 개강 1일전</td>
                  <td>전액 활불</td>
                  <td rowspan="4">수강 취소일 기준<br>개강 후 재료비는 환불 불가</td>
                </tr>
                <tr>
                  <td>당일, 개강후 1/3 경과 전</td>
                  <td>수강료의 2/3 해당 금액</td>
                </tr>
                <tr>
                  <td>개강 후 1/2 경과 전</td>
                  <td>수강료의 1/2 해당 금액</td>
                </tr>
                <tr>
                  <td>개강 후 1/2 경과 </td>
                  <td>환불 불가</td>
                </tr>
              </tbody>
            </table>
            <p class="area-box__middle-section">3. 유의 사항</p>
            <ul>
              <li>•신용카드 결제 신청자의 개강 후 환불은 무통장 입금(계좌이체)으로 환불</li>
              <li>- 개강 전 취소는 100% 환불(카드 취소)</li>
              <li>- 개강 후 부분 환불은 환불 신청자 명의 계좌로 무통장 입금</li>
            </ul>
            <h4 class="text-area-box__section-title center" style="color: #1E8732;">영등포50플러스센터</h4>
            <p class="area-box__middle-section">※근거</p>
            <ul>
              <li>「평생교육법 시행령(제23조제2항) 학습비 반환기준 및 소비자분쟁해결기준」</li>
            </ul>
            <p class="area-box__middle-section">1. 신청 방법</p>
            <ul>
              <li>•홈페이지 로그인 ⇒ 마이페이지 內 수강확인 및 취소 ⇒ 환불 처리(신청일로부터 7일 이내, 본인 명의 계좌로 환급)</li>
            </ul>
            <p class="area-box__middle-section">2. 환불 기준</p>
            <ul>
              <li>•개강일 이전은 전액 환급되며, 개강일 이후는 남은 기간을 산정하여 수강료가 환급</li>
            </ul>
            <table>
              <caption>환불기준 표</caption>
              <colgroup>
                <col width="20%"/>
                <col width="30%"/>
                <col width="50%"/>
              </colgroup>
              <thead>
                <tr>
                  <th scope="col" style="background: #006ffb !important;">구분</th>
                  <th scope="col" style="background: #006ffb !important;">반환사유 발생일</th>
                  <th scope="col" style="background: #006ffb !important;">반환금액</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td rowspan="4">학습비 징수기간이<br>1개월 이내인 경우</td>
                  <td>수업시작 전</td>
                  <td>이미 낸 학습비 전액</td>
                </tr>
                <tr>
                  <td>총 수업시간의 1/3 경과 전</td>
                  <td>이미 낸 학습비의 2/3 해당 금액</td>
                </tr>
                <tr>
                  <td>총 수업시간의 1/2 경과 전 </td>
                  <td>이미 낸 학습비의 1/2 해당 금액</td>
                </tr>
                <tr>
                  <td>총 수업시간의 1/2 경과 후</td>
                  <td>반환하지 아니함</td>
                </tr>
                <tr>
                  <td rowspan="2">학습비 징수기간이<br>1개월을 초과하는 경우</td>
                  <td>수업시작 전</td>
                  <td>이미 낸 학습비 전액</td>
                </tr>
                <tr>
                  <td>1일 특강 및 단기 특강</td>
                  <td>환불요청일 당해 월의 반환 학습비(학습비 징수기간이 1개월 이내인 경우에 준하여 산출된 학습비를 말한다)와 나머지 잔여달(잔여회차)의 학습비 전액을 합산한 금액</td>
                </tr>
                <tr>
                  <td>수업시작 후</td>
                  <td colspan="2">개강일 이전까지만 전액 환불 가능</td>
                </tr>
                <tr>
                  <td>비고</td>
                  <td colspan="2" style="text-align: left;">1. ‘학습비 징수기간’이란 징수된 총학습비에 따른 총 수업일을 말한다.
<br>&nbsp;※ 징수기간에서 1개월이란 「평생교육시설 관련 학습비 반환기준 해석지침」에 의거 강의 시작일로부터 적용
<br>
<br>2. ‘총 수업시간’이란 학습비 징수기간 중의 총 수업시간(회차)을 말한다.
<br>&nbsp;※ 반환금액의 산정은 반환사유가 발생한 날까지 경과된 수업시간을 기준으로, 학습 포기 의사를 
<br>&nbsp;&nbsp;&nbsp;밝힌 날의 다음날부터 계산하여 반환함
<br>&nbsp;※ 환불시 10원 미만은 절사함</td>
                </tr>
              </tbody>
            </table>
            <p class="area-box__middle-section">3. 유의 사항</p>
            <ul>
              <li>•개강 후 재료비는 환불 불가</li>
              <li>•개강 중 중간신청자도 강좌개강일 시점으로 동일한 환불기준이 적용됨</li>
            </ul>
            <h4 class="text-area-box__section-title center" style="color: #1E8732;">노원50플러스센터</h4>
            <p class="area-box__middle-section">※근거</p>
            <ul>
              <li>「평생교육법 시행령(제23조제2항) 학습비 반환기준 및 소비자분쟁해결기준」</li>
            </ul>
            <p class="area-box__middle-section">1. 신청 방법</p>
            <ul>
              <li>홈페이지 로그인 ⇒ 마이페이지 內 수강확인 및 취소 ⇒ 환불 처리(신청일로부터 2주 이내, 본인 명의 계좌로 환급)</li>
            </ul>
            <p class="area-box__middle-section">2. 환불 기준</p>
            <ul>
              <li>• 환불기준 : 수강료 환불신청일 기준(수강여부와 무관)</li>
            </ul>
            <table>
              <caption>환불기준 표</caption>
              <colgroup>
                <col width="50%"/>
                <col width="50%"/>
              </colgroup>
              <thead>
                <tr>
                  <th scope="col" style="background: #006ffb !important;">반환 사유 발생일</th>
                  <th scope="col" style="background: #006ffb !important;">환불 금액</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>센터 사정, 천재지변</td>
                  <td>수강료 전액 환불</td>
                </tr>
                <tr>
                  <td>수업시작 1일전까지</td>
                  <td>수강료 전액 환불</td>
                </tr>
                <tr>
                  <td>수업당일 ~ 총 수업기간의 1/3경과 전 (회차기준)</td>
                  <td>수강료의 2/3 해당금액 환불</td>
                </tr>
                <tr>
                  <td>총 수업기간의 1/2경과 전 (회차기준)</td>
                  <td>수강료의 1/2 해당금액 환불</td>
                </tr>
                <tr>
                  <td>총 수업기간의 1/2 경과 (회차기준)</td>
                  <td>환불 불가능</td>
                </tr>
              </tbody>
            </table>
            <ul>
              <li>• 무통장입금, 카드결제 모두 반드시 본인명의 계좌번호 입력(필수)</li>
              <li>• 본인명의 계좌번호 아니거나 계좌번호 작성오류 시 지급가능한 본인명의 통장사본 제출</li>
            </ul>
            <p class="area-box__middle-section">3. 유의 사항</p>
            <ul>
              <li>• 개강 후(개강당일포함) 재료비 및 교재비는 환불 불가</li>
              <li>• 개강 중 중간신청자도 강좌개강일 시점으로 동일한 환불기준이 적용됨</li>
              <li>• 신용카드 결제 신청자의 개강 후 환불은 무통장 입금(계좌이체)으로 환불</li>
              <li>- 개강 전 취소는 100% 환불(카드 취소)</li>
              <li>- 개강 후 일부 환불은 환불 신청자 명의 계좌로 무통장 입금</li>
              <li>• 환불금액 10원 미만 금액은 절사</li>
            </ul>
            <h4 class="text-area-box__section-title center" style="color: #1E8732;">서대문50플러스센터</h4>
            <p class="area-box__middle-section">※근거</p>
            <ul>
              <li>「평생교육법 시행령(제23조제2항) 학습비 반환기준 및 소비자분쟁해결기준」</li>
            </ul>
            <p class="area-box__middle-section">1. 신청 방법</p>
            <ul>
              <li>•홈페이지 로그인 ⇒ 마이페이지 內 수강확인 및 취소 ⇒ 환불 처리(신청일로부터 2주 이내, 본인 명의 계좌로 환급)</li>
            </ul>
            <p class="area-box__middle-section">2. 환불 기준</p>
            <ul>
              <li>•개강일 이전은 전액 환급되며, 개강일 이후는 남은 기간을 산정하여 수강료가 환급</li>
            </ul>
            <table>
              <caption>환불기준 표</caption>
              <colgroup>
                <col width="20%"/>
                <col width="30%"/>
                <col width="50%"/>
              </colgroup>
              <thead>
                <tr>
                  <th scope="col" style="background: #006ffb !important;">구분</th>
                  <th scope="col" style="background: #006ffb !important;">반환사유 발생일</th>
                  <th scope="col" style="background: #006ffb !important;">반환금액</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td rowspan="4">학습비 징수기간이<br>1개월 이내인 경우</td>
                  <td>수업시작 전</td>
                  <td>이미 낸 학습비 전액</td>
                </tr>
                <tr>
                  <td>총 수업시간의 1/3 경과 전</td>
                  <td>이미 낸 학습비의 2/3 해당 금액</td>
                </tr>
                <tr>
                  <td>총 수업시간의 1/2 경과 전 </td>
                  <td>이미 낸 학습비의 1/2 해당 금액</td>
                </tr>
                <tr>
                  <td>총 수업시간의 1/2 경과 후</td>
                  <td>반환하지 아니함</td>
                </tr>
                <tr>
                  <td rowspan="2">학습비 징수기간이<br>1개월을 초과하는 경우</td>
                  <td>수업시작 전</td>
                  <td>이미 낸 학습비 전액</td>
                </tr>
                <tr>
                  <td>수업시작 후</td>
                  <td>환불요청일 당해 월의 반환 학습비(학습비 징수기간이 1개월 이내인 경우에 준하여 산출된 학습비를 말한다)와 나버지 잔여달(잔여회차)의 학습비 전액을 합산한 금액</td>
                </tr>
                <tr>
                  <td>1일 특강 및 단기 특강</td>
                  <td colspan="2">개강일 이전까지만 전액 환불 가능</td>
                </tr>
                <tr>
                  <td>비고</td>
                  <td colspan="2" style="text-align: left;">1. ‘학습비 징수기간’이란 징수된 총학습비에 따른 총 수업일을 말한다.
<br>&nbsp;※ 징수기간에서 1개월이란 「평생교육시설 관련 학습비 반환기준 해석지침」에 의거 강의 시작일로부터 적용
<br>
<br>2. ‘총 수업시간’이란 학습비 징수기간 중의 총 수업시간(회차)을 말한다.
<br>&nbsp;※ 반환금액의 산정은 반환사유가 발생한 날까지 경과된 수업시간을 기준으로, 학습 포기 의사를 
<br>&nbsp;&nbsp;&nbsp;밝힌 날의 다음날부터 계산하여 반환함
<br>&nbsp;※ 환불시 10원 미만은 절사함</td>
                </tr>
              </tbody>
            </table>
            <p class="area-box__middle-section">3. 유의 사항</p>
            <ul>
              <li>•개강 후 재료비는 환불 불가</li>
              <li>•개강 중 중간신청자도 강좌개강일 시점으로 동일한 환불기준이 적용됨</li>
              <li>•신용카드 결제 신청자의 개강 후 환불은 무통장 입금(계좌이체)으로 환불</li>
              <li>- 개강 전 취소는 100% 환불(카드 취소)</li>
              <li>- 개강 후 일부 환불은 환불 신청자 명의 계좌로 무통장 입금</li>
            </ul>
            <h4 class="text-area-box__section-title center" style="color: #1E8732;">성북50플러스센터</h4>
            <p class="area-box__middle-section">※근거</p>
            <ul>
              <li>「평생교육법 시행령(제23조제2항) 학습비 반환기준 및 소비자분쟁해결기준」</li>
            </ul>
            <p class="area-box__middle-section">1. 신청 방법</p>
            <ul>
              <li>• 홈페이지 로그인 → 마이페이지 → 내강좌 → 수강확인 및 취소</li>
              <li>• 수강생 명과 동일한 예금주의 계좌번호/은행 입력 (※ 카드결제의 경우도 계좌번호 작성해야 함)</li>
              <li>• 개강 전 취소: 개강일 이후 1주 이내</li>
              <li>• 개강 이후 취소: 환불신청일로부터 2주 이내</li>
            </ul>
            <p class="area-box__middle-section">2. 환불 기준</p>
            <ul>
              <li>• 1일 특강은 '개강일 이전' 까지만 전액환불 가능</li>
              <li>• (수강취소일 기준) 총 수강횟수의 1/3 경과 전: 납부한 수강료의 2/3 해당액</li>
              <li>• (수강취소일 기준) 총 수강횟수의 1/2 경과 전: 납부한 수강료의 1/2 해당액</li>
              <li>• (수강취소일 기준) 총 수강횟수의 1/2 경과 후: 납부한 수강료 전액 반환하지 않음.</li>
            </ul>
            <p class="area-box__middle-section">3. 유의 사항</p>
            <ul>
              <li>• 개강 후 재료비 및 교재비 등은 환불 불가</li>
              <li>• 개강 후 '중간신청자'의 경우도 동일하게 '강좌개강일'을 기점으로 동일한 환불 기준 적용</li>
              <li>• 실제 수강여부와 무관하게 '마이페이지-내강좌' 메뉴에서 수강취소를 진행한 '수강취소일'을 기준으로 환불금액 산정</li>
            </ul>
            <h4 class="text-area-box__section-title center" style="color: #1E8732;">금천50플러스센터</h4>
            <p class="area-box__middle-section">※근거</p>
            <ul>
              <li>「평생교육법 시행령(제23조제2항) 학습비 반환기준 및 소비자분쟁해결기준」</li>
            </ul>
            <p class="area-box__middle-section">1. 신청 방법</p>
            <ul>
              <li>• 홈페이지 로그인 ⇒ 마이페이지 내 수강확인 및 취소 ⇒ 은행·계좌번호 작성 ⇒ 수강생명 및 예금주 동일 여부를 확인 </li>
              <li>&nbsp;&nbsp;&nbsp; ⇒ 환불 처리(신청일로부터 2주 이내, 본인 명의 계좌로 환급)</li>
            </ul>
            <p class="area-box__middle-section">2. 환불 기준</p>
            <ul>
              <li>• 홈페이지 내 온라인 접수를 통해서만 환불 가능하며, 방문 및 유선으로는 불가능하다.</li>
            </ul>
            <table>
              <caption>환불기준 표</caption>
              <colgroup>
                <col width="60%"/>
                <col width="40%"/>
              </colgroup>
              <thead>
                <tr>
                  <th scope="col" style="background: #006ffb !important;">반환사유 발생일</th>
                  <th scope="col" style="background: #006ffb !important;">반환금액</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>모집정원 미달로 폐강 시, 1일 특강 및 강좌 개강일 전</td>
                  <td>전액 환불</td>
                </tr>
                <tr>
                  <td>수강취소일 기준 총 수강 횟수의 1/3 경과 전</td>
                  <td>납부 수강료의 2/3 해당 금액</td>
                </tr>
                <tr>
                  <td>수강취소일 기준 총 수강 횟수의 1/2 경과 전 </td>
                  <td>납부 수강료의 1/2 해당 금액</td>
                </tr>
                <tr>
                  <td>수강취소일 기준 총 수강 횟수의 1/2 경과 후</td>
                  <td>반환하지 아니함</td>
                </tr>
                <tr>
                  <td style="text-align: left;" colspan="2">센터의 사정으로 교육프로그램이 취소 또는 정지되거나 천재지변·재해, 전염성 질병 또는 이에 준하는 사유로 교육프로그램의 진행이 불가능한 경우 수강횟수를 제외한 잔여 횟수에 해당하는 금액을 계산하여 반환</td>
                </tr>
                <tr>
                  <td style="text-align: left;" colspan="2">•수강생의 수강취소 및 모집정원 미달로 인한 폐강, 센터의 사정으로 교육프로그램이 취소 또는 정지되거나
천재지변·재해, 전염성 질병 또는 이에 준하는 사유 등으로 환불이 발생할 경우 환불 기준에 따라 수강료    전액 또는 일부를 환불사유 발생일로부터 운영일 기준 7일 이내 지급한다.
<br>
<br>•센터 지정 은행 외 타 은행 계좌 환불 요청 시 수수료 발생분은 수강생이 부담하며, 개강 후 재료, 교재비환불이 불가능하다.
<br>※ 수수료 발생 부분 : 타 은행 계좌 이체 시 수수료, 카드취소 시 발생되는 사업자 수수료 등
<br>
<br>• 개강 후 수강 취소 시 프로그램별 교재비와 재료비 등 강의 과정에 수반되는 비용은 환불이 불가하다. 다만, 자격증 발급비용 등 강의 진행 과정과 별도로 산정된 비용은 협의를 통해 환불을 진행할 수 있다.
<br>
<br>• 환불 금액은 원 단위 절상하여 지급한다.</td>
                </tr>
              </tbody>
            </table>
            <p class="area-box__middle-section">3. 유의 사항</p>
            <ul>
              <li>• 개강 중 중간신청자도 강좌개강일 시점으로 동일한 환불기준이 적용됨</li>
              <li>• 결제 방법에 따라 카드결제 건은 카드취소로, 무통장 입금 건은 계좌이체로 환불 진행.</li>
            </ul>
            <h4 class="text-area-box__section-title center" style="color: #1E8732;">강서50플러스센터</h4>
            <p class="area-box__middle-section">※근거</p>
            <ul>
              <li>「서울특별시 강서구 중·장년층 인생이모작 지원에 관한 조례 시행규칙(제4조 사용료 등의 반환)」</li>
            </ul>
            <p class="area-box__middle-section">1. 신청 방법</p>
            <ul>
              <li>• 홈페이지 로그인 → 마이페이지 → 내강좌 → 수강확인 및 취소</li>
              <li>• 수강생 명과 예금주의 계좌번호/은행 입력 (※카드결제의 경우 계좌번호 작성해야 함)</li>
            </ul>
            <p class="area-box__middle-section">2. 환불 기준</p>
            <ul>
              <li>• 개강 1일 전까지는 납부한 수강료 전액 환불</li>
              <li>• (수강취소일 기준) 총 수강횟수의 1/3 경과 전 : 납부한 수강료의 2/3 해당액</li>
              <li>• (수강취소일 기준) 총 수강횟수의 1/2 경과 전 : 납부한 수강료의 1/2 해당액</li>
              <li>• (수강취소일 기준) 총 수강횟수의 1/2 경과 후 : 환불 불가.</li>
              <li>※ 기관 사정과 모집정원 미달에 의한 폐강 시 폐강 공고 후 전액 환불.</li>
              <li>※ 환불시 10원 미만은 올림함.</li>
            </ul>
            <p class="area-box__middle-section">3. 유의 사항</p>
            <ul>
              <li> • 환불처리는 환불 신청일로부터 2주 이내.</li>
              <li>※ 연간 2회이상 환불자는 이후 교육신청 시 후순위(대기자)로 선정될 수 있음.</li>
              <li>※ 개강일 이후 재료비 및 교재비 등은 환불 불가.</li>
              <li>※ 유료강좌의 경우 환불신청 계좌번호 입력.</li>
            </ul>
            <h4 class="text-area-box__section-title center" style="color: #1E8732;">서초50플러스센터</h4>
            <p class="area-box__middle-section">※근거</p>
            <ul>
              <li>「평생교육법 시행령(제23조제2항) 학습비 반환기준 및 소비자분쟁해결기준」</li>
            </ul>
            <p class="area-box__middle-section">1. 신청 방법</p>
            <ul>
              <li>•홈페이지 로그인 ⇒ 마이페이지 內 수강확인 및 취소 ⇒ 환불 처리(신청일로부터 2주 이내, 본인 명의 계좌로 환급)</li>
            </ul>
            <p class="area-box__middle-section">2. 환불 기준</p>
            <ul>
              <li>•개강일 이전은 전액 환급되며, 개강일 이후는 남은 기간을 산정하여 수강료가 환급</li>
            </ul>
            <table>
              <caption>환불기준 표</caption>
              <colgroup>
                <col width="20%"/>
                <col width="30%"/>
                <col width="50%"/>
              </colgroup>
              <thead>
                <tr>
                  <th scope="col" style="background: #006ffb !important;">구분</th>
                  <th scope="col" style="background: #006ffb !important;">반환사유 발생일</th>
                  <th scope="col" style="background: #006ffb !important;">반환금액</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>개강일 전</td>
                  <td>수업시작 전</td>
                  <td>이미 낸 학습비 전액</td>
                </tr>
                <tr>
                  <td rowspan="4">개강일 이후<br>(개강 당일 포함)</td>
                  <td>총 수업시간의 1/3 경과 전</td>
                  <td>이미 낸 학습비의 2/3 해당 금액</td>
                </tr>
                <tr>
                  <td>총 수업시간의 1/2 경과 전 </td>
                  <td>이미 낸 학습비의 1/2 해당 금액</td>
                </tr>
                <tr>
                  <td>총 수업시간의 1/2 경과 후</td>
                  <td rowspan="2">반환하지 아니함</td>
                </tr>
                <tr>
                  <td>1회기 강의</td>
                </tr>
                <tr>
                  <td>비고</td>
                  <td style="text-align: left;" colspan="2">※ 개강 후 교재비, 재료비는 환불 불가<br>※ 환불시 원단위 절사함</td>
                </tr>
              </tbody>
            </table>
            <p class="area-box__middle-section">3. 유의 사항</p>
            <ul>
              <li>•개강 후 재료비는 환불 불가</li>
              <li>•신용카드 결제 신청자의 개강 후 환불은 카드 부분취소로 환불</li>
            </ul>
            <h4 class="text-area-box__section-title center" style="color: #1E8732;">강동50플러스센터</h4>
            <p class="area-box__middle-section">※근거</p>
            <ul>
              <li>「서울특별시 강동구 장년층 인생이모작 지원조례」제9조 (사용료 등) </li>
            </ul>
            <p class="area-box__middle-section">1. 신청 방법</p>
            <ul>
              <li>•홈페이지 로그인 ⇒ 마이페이지 內 수강확인 및 취소 ⇒ 환불 처리(신청일로부터 2주 이내, 카드결제인 경우 카드 (부분)취소 처리/무통장입금의 경우 본인 명의 계좌로 환급됨)</li>
            </ul>
            <p class="area-box__middle-section">2. 환불 기준</p>
            <ul>
              <li>•개강일 이전은 전액 환급되며, 개강일 이후는 남은 기간을 산정하여 수강료가 환급</li>
            </ul>
            <table>
              <caption>환불기준 표</caption>
              <colgroup>
                <col width="60%"/>
                <col width="40%"/>
              </colgroup>
              <thead>
                <tr>
                  <th scope="col" style="background: #006ffb !important;">내용</th>
                  <th scope="col" style="background: #006ffb !important;">환불 기준</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>모집정원 미달로 폐강하는 경우</td>
                  <td>수강료 전액 반환</td>
                </tr>
                <tr>
                  <td>1일특강 및 강좌 개강일 전일까지 취소하는 경우</td>
                  <td>수강료 전액 반환</td>
                </tr>
                <tr>
                  <td>개강일부터 총 수강횟수의 3분의 1이 경과하기 전까지 취소하는 경우</td>
                  <td>수강료 3분의 2 반환</td>
                </tr>
                 <tr>
                  <td>총 수강횟수의 3분의 1 경과 이후부터 2분의 1이 경과하기 전까지 취소하는 경우</td>
                  <td>수강료 2분의 1 반환</td>
                </tr>
                 <tr>
                  <td>총 수강횟수 2분의 1 경과 이후 취소</td>
                  <td>수강료 미반환</td>
                </tr>
                 <tr>
                  <td>인생이모작 지원시설의 사정으로 프로그램이 취소 또는 정지되거나 천재지변·재해 또는 이에 준하는 사유로 프로그램 진행이 불가능한 경우</td>
                  <td>수강횟수를 제외한 잔여 횟수에 해당되는 금액을 계산하여 반납</td>
                </tr>
              </tbody>
            </table>
            <p class="area-box__middle-section">3. 유의 사항</p>
            <ul>
              <li>•환불액 산정은 반환사유가 발생한 날까지를 경과된 수업시간으로 책정함.</li>
              <li>&nbsp;즉, 학습포기 의사를 밝힌 날의 다음 날부터 계산하여 반환함</li>
              <li>&nbsp;(단, 학습포기의사를 밝힌 날은 실제 수강여부와 상관없이 홈페이지에서 수강취소를 진행한 해당일로 봄)</li>
              <li>•환불시 10원 미만은 절사함</li>
              <li>•센터의 지정 은행 외 타 은행 계좌환불 요청시 수수료는 수강생이 직접 부담하며 개강 후 재료비 및 교재비는 환불 불가능 합니다.</li>
              <li>&nbsp;-수수료 발생 부분: 타 은행 계좌이체시 수수료, 카드 취소시 발생된는 사업자 수수료</li>
              <li>•개강 후 중간에 신청한 경우에도 강좌 개강일 시점으로 동일한 환불 기준을 적용합니다.</li>
            </ul>
            <h4 class="text-area-box__section-title center" style="color: #1E8732;">양천50플러스센터</h4>
            <p class="area-box__middle-section">※근거</p>
            <ul>
              <li>「평생교육법 시행령(제23조제2항) 학습비 반환기준 및 소비자분쟁해결기준」</li>
            </ul>
            <p class="area-box__middle-section">1. 신청 방법</p>
            <ul>
              <li>•홈페이지 로그인 ⇒ 마이페이지 內 수강확인 및 취소 ⇒ 환불 처리(신청일로부터 2주 이내, 본인 명의 계좌로 환급)</li>
            </ul>
            <p class="area-box__middle-section">2. 환불 기준</p>
            <ul>
              <li>•개강일 이전은 전액 환급되며, 개강일 이후는 남은 기간을 산정하여 수강료가 환급</li>
            </ul>
            <table>
              <caption>환불기준 표</caption>
              <colgroup>
                <col width="20%"/>
                <col width="30%"/>
                <col width="50%"/>
              </colgroup>
              <thead>
                <tr>
                  <th scope="col" style="background: #006ffb !important;">구분</th>
                  <th scope="col" style="background: #006ffb !important;">반환사유 발생일</th>
                  <th scope="col" style="background: #006ffb !important;">반환금액</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td rowspan="4">학습비 징수기간이<br>1개월 이내인 경우</td>
                  <td>수업시작 전</td>
                  <td>이미 낸 학습비 전액</td>
                </tr>
                <tr>
                  <td>총 수업시간의 1/3 경과 전</td>
                  <td>이미 낸 학습비의 2/3 해당 금액</td>
                </tr>
                <tr>
                  <td>총 수업시간의 1/2 경과 전 </td>
                  <td>이미 낸 학습비의 1/2 해당 금액</td>
                </tr>
                <tr>
                  <td>총 수업시간의 1/2 경과 후</td>
                  <td>반환하지 아니함</td>
                </tr>
                <tr>
                  <td rowspan="2">학습비 징수기간이<br>1개월을 초과하는 경우</td>
                  <td>수업시작 전</td>
                  <td>이미 낸 학습비 전액</td>
                </tr>
                <tr>
                  <td>수업시작 후</td>
                  <td style="text-align: left;">환불요청일 당해 월의 반환 학습비(학습비 징수기간이 1개월 이내인 경우에 준하여 산출된 학습비를 말한다)와 나머지 잔여달(잔여회차)의 학습비 전액을 합산한 금액</td>
                </tr>
                <tr>
                  <td>1일 특강 및 단기 특강</td>
                  <td colspan="2">개강일 이전까지만 전액 환불 가능</td>
                </tr>
                <tr>
                  <td>비고</td>
                  <td style="text-align: left;" colspan="2">1. ‘학습비 징수기간’이란 징수된 총학습비에 따른 총 수업일을 말한다.
<br>&nbsp;※ 징수기간에서 1개월이란 「평생교육시설 관련 학습비 반환기준 해석지침」에 의거 강의 시작일로부터 적용
<br>
<br>2. ‘총 수업시간’이란 학습비 징수기간 중의 총 수업시간(회차)을 말한다.
<br>&nbsp;※ 반환금액의 산정은 반환사유가 발생한 날까지 경과된 수업시간(회차)을 기준으로, 학습 포기 의사를 밝힌 날의 다음날부터 계산하여 반환함
<br>&nbsp;※ 환불시 10원 미만은 절사함</td>
                </tr>
              </tbody>
            </table>
            <p class="area-box__middle-section">3. 유의 사항</p>
            <ul>
              <li>•개강 후 재료비는 환불 불가</li>
              <li>•개강 중 중간신청자도 강좌개강일 시점으로 동일한 환불기준이 적용됨</li>
              <li>•신용카드 결제 신청자의 개강 후 환불은 카드사에서 부분 취소 후 무통장 입금(계좌이체)으로 환불</li>
              <li>- 개강 전 취소는 100% 환불(카드 취소)</li>
              <li>- 개강 후 일부 환불은 환불 신청자 명의 계좌로 무통장 입금</li>
            </ul>
            <h4 class="text-area-box__section-title center" style="color: #1E8732;">성동50플러스센터</h4>
            <p class="area-box__middle-section">※근거</p>
            <ul>
              <li>「평생교육법 시행령(제23조제2항) 학습비 반환기준</li>
            </ul>
            <p class="area-box__middle-section">1. 신청 방법</p>
            <ul>
              <li>• 홈페이지 [로그인] → [마이페이지] → [내강좌] → [수강확인] 및 취소</li>
              <li>• 수강생 명과 본인 명의의 계좌번호/은행 입력 (※카드결제의 경우도 계좌번호 작성해야 함)</li>
              <li>• 환불 신청일로부터 2주 이내 환불처리</li>
            </ul>
            <p class="area-box__middle-section">2. 환불 기준</p>
            <table>
              <caption>환불기준 표</caption>
              <colgroup>
                <col width="20%"/>
                <col width="30%"/>
                <col width="50%"/>
              </colgroup>
              <thead>
                <tr>
                  <th scope="col" style="background: #006ffb !important;">구분</th>
                  <th scope="col" style="background: #006ffb !important;">반환사유 발생일</th>
                  <th scope="col" style="background: #006ffb !important;">반환금액</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td></td>
                  <td>수업을 할 수 없거나, 수업 장소를 제공할 수 없게 된 날</td>
                  <td>이미 낸 학습비를 일할 예산한 금액</td>
                </tr>
                <tr>
                  <td rowspan="4">학습비 징수기간이<br>1개월 이내인 경우</td>
                  <td>수업시작 전</td>
                  <td>이미 낸 학습비 전액</td>
                </tr>
                <tr>
                  <td>총 수업시간의 1/3 경과 전</td>
                  <td>이미 낸 학습비의 2/3 해당 금액</td>
                </tr>
                <tr>
                  <td>총 수업시간의 1/2 경과 전 </td>
                  <td>이미 낸 학습비의 1/2 해당 금액</td>
                </tr>
                <tr>
                  <td>총 수업시간의 1/2 경과 후</td>
                  <td>반환하지 아니함</td>
                </tr>
                <tr>
                  <td rowspan="2">학습비 징수기간이<br>1개월을 초과하는 경우</td>
                  <td>수업시작 전</td>
                  <td>이미 낸 학습비 전액</td>
                </tr>
                <tr>
                  <td>수업시작 후</td>
                  <td style="text-align: left;">환불요청일 당해 월의 반환 학습비(학습비 징수기간이 1개월 이내인 경우에 준하여 산출된 학습비를 말한다)와 나버지 잔여달(잔여회차)의 학습비 전액을 합산한 금액</td>
                </tr>
                <tr>
                  <td>1일 특강 및 단기 특강</td>
                  <td style="text-align: left;" colspan="2">개강일 이전까지만 전액 환불 가능</td>
                </tr>
                <tr>
                  <td>비고</td>
                  <td style="text-align: left;" colspan="2">1. “학습비 징수기간”이란 징수된 총학습비에 따른 총수업일을 말한다.
<br>2. “총수업시간”이란 학습비 징수기간 중의 총수업시간(회차)를 말한다.
<br>3. 반환금액의 산정은 반환사유가 발생한 날까지 경과된 수업시간을 기준으로 한다.</td>
                </tr>
              </tbody>
            </table>
            <p class="area-box__middle-section">3. 유의 사항</p>
            <ul>
              <li>• 수강취소는 '[마이페이지] - [내강좌]' 메뉴에서 진행가능</li>
              <li>• 개강일 이후 재료비 및 교재비 등은 환불 불가</li>
              <li>• 수강취소일 기준은 실제 수강여부와 무관하게 수강취소를 진행한 해당일 기준</li>
            </ul>
            <h4 class="text-area-box__section-title center" style="color: #1E8732;">강북50플러스센터</h4>
            <p class="area-box__middle-section">※근거</p>
            <ul>
              <li>「평생교육법 시행령(제23조제2항) 학습비 반환기준 및 소비자분쟁해결기준」</li>
            </ul>
            <p class="area-box__middle-section">1. 신청 방법</p>
            <ul>
              <li>•환불 신청 방법</li>
              <li>- 홈페이지 로그인 → 마이페이지 → 내 강좌 → 수강 확인 및 취소 </li>
              <li>- 수강생 명과 예금주의 계좌번호 / 은행 입력 (※ 카드결제경우에도 계좌번호 작성 必)</li>
              <li>- 개강 후 수강 취소 시 교재비, 재료비는 환불 불가</li>
            </ul>
            <p class="area-box__middle-section">2. 환불 기준</p>
            <ul>
              <li>•학습비 징수기간 : 징수된 총 학습비에 따른 총 수업일</li>
              <li>•총 수업시간: 장수기간 중의 총 수업시간</li>
              <li>•반환금액 산정은 반환사유가 발생한 날까지 경과된 수업일 기준</li>
            </ul>
            <table>
              <caption>환불기준 표</caption>
              <colgroup>
                <col width="15%"/>
                <col width="15%"/>
                <col width="30%"/>
                <col width="40%"/>
              </colgroup>
              <thead>
                <tr>
                  <th scope="col" style="background: #006ffb !important;" colspan="2">구분</th>
                  <th scope="col" style="background: #006ffb !important;">반환사유 발생일</th>
                  <th scope="col" style="background: #006ffb !important;">반환금액</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td colspan="2">1. 법 제28조 제 4항 제1호 및 제2호에 따른 반환사유의 경우</td>
                  <td>수업을 할 수 없거나 수업장소를 제공할 수 없게 된 날 </td>
                  <td>이미 낸 학습단위를 일 단위로 계산한 금액</td>
                </tr>
                <tr>
                  <td rowspan="6">2. 법 제 28조 제4항 제3호에 따른 반환사유의 경우</td>
                  <td rowspan="4">가. 학습비 징수기간이<br>1개월 이내인 경우</td>
                  <td style="text-align: left;">&nbsp;1) 수업시작 전</td>
                  <td>이미 낸 학습비 전액</td>
                </tr>
                <tr>
                  <td>2)　총 수업시간의 1/3 경과 전</td>
                  <td>이미 낸 학습비의 2/3 해당 금액</td>
                </tr>
                <tr>
                  <td>3) 총 수업시간의 1/2 경과 전 </td>
                  <td>이미 낸 학습비의 1/2 해당 금액</td>
                </tr>
                <tr>
                  <td>4) 총 수업시간의 1/2 경과 후</td>
                  <td>반환하지 아니함</td>
                </tr>
                <tr>
                  <td rowspan="2">나. 학습비 징수기간이 1개월을 초과하는 경우</td>
                  <td style="text-align: left;">1) 수업시작 전</td>
                  <td style="text-align: left;">이미 낸 학습비 전액</td>
                </tr>
                 <tr>
                  <td style="text-align: left;">2) 수업시작 후</td>
                  <td style="text-align: left;">환불요청일 당해 월의 반환 학습비(학습비 징수기간이 1개월 이내인 경우에 준하여 산출된 학습비를 말한다)와 나버지 잔여달(잔여회차)의 학습비 전액을 합산한 금액</td>
                </tr>
                <tr>
                  <td colspan="2">환불 기준</td>
                  <td colspan="2" style="text-align: left;">- 수강취소일 기준: 실제 수강여부와 무관하게 수강취소를 진행한 해당일 기준
<br>- 온라인 상 환불요청일자를 취소일로 계산하고 원단위 절사 </td>
                </tr>
              </tbody>
            </table>
            <p class="area-box__middle-section">3. 유의 사항</p>
            <ul>
              <li>- 폐강으로 인한 환불대상자는 전화상담 후 환불처리</li>
              <li>- 개강 후 수강 취소 시 교재비, 재료비는 환불 불가</li>
            </ul>
          </div>
        </div>
        <div class="block-input-group clearfix" tabIndex="0">
          <div class="text-area-box" id="photo-agree">
          <label class="block-input-label" for="photo-agree">사진 및 영상촬영 동의</label>
            <ul>
              <li>교육 시 사진 및 영상촬영을 진행할 수 있습니다.</li>
              <li>해당 촬영결과물은 언론보도자료 또는 행사기록용 등이 비영리목적으로만 활용됩니다.</li>
            </ul>
            <br>
          <label class="block-input-label" for="photo-agree">온라인 교육 등에 따른 강의자료(영상) 무단 복제 및 배포 금지</label>
            <ul>
              <li>※ 위반 시 저작권법(제18조, 20조, 22조, 136조)에 의거, 모든 책임은 본인에게 있습니다.</li>
            </ul>
          </div>
        </div>

        <label class="checkbox-inline label__radio" for="cofirm-agree">
          <input class="input__checkbox" type="checkbox" id="cofirm-agree" v-model="agree" title="cofirm-agree 선택">
          위 내용을 모두 확인하였으며 동의합니다.
        </label>

        <div class="form-submit-gruop">
          <button type="button" class="form-submit__btn line-btn--red" @click="goToPrevious">이전</button>
          <button type="button" class="form-submit__btn btn--blue-line" @click="apply">신청하기</button>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
  /* global daum */
  import axios from 'axios';
  
  const emailCheckList = {
    Y: '수신',
    N: '거부',
  };

  const smsCheckList = {
    Y: '수신',
    N: '거부',
  };

  const occuList = [
    '경영/금융/사무/보험',
    '공무원(교사)',
    '교육/강사/연구/법률',
    '의료/보건/사회복지',
    '마케팅/무역',
    '전문직(의사/변호사 등)',
    '문화/예술/신문방송/디자인',
    '영업/판매/고객상담/CS',
    '건설/건축/환경/산업',
    'IT/정보통신/웹',
    '숙박/음식/여행/스포츠/경비청소',
    '전업주부',
    '무직',
    '기타',
  ];
  const emailList = [
    'naver.com',
    'hanmail.net',
    'daum.net',
    'gmail.com',
    'google.com',
    'nate.com',
    'yahoo.com',
    'paran.com',
    'korea.com',
    'freechal.com',
  ];
  const joinPurpose = [
    '인생후반전 준비에 대한 인식을 가지고자',
    '사회공헌 및 자원봉사에 관심이 있어서',
    'NGO 등 인생후반전을 위한 단체를 구성하기 위해서',
    '창업을 위해서',
    '재취업을 위해서',
    '생각이나 취미가 같은 사람들을 만나기 위해',
  ];
  const applyPath = [
    '서울시 유관홈페이지',
    '언론보도',
    '홍보책자',
    '옥외광고',
    '미디어광고',
    '인터넷/SNS 검색',
    '타 기관 안내',
  ];
  export default {
    name: 'course-form',
    props: ['member', 'lecture', 'forms', 'orgList', 'orgCode'],
    data() {
      return {
        step: 1,
        application: {
          motive: '',
          forms: [],
          discount: '',
        },
        discount: '',
        discountEtc: null,
        answers: [],
        date: null,
        selectedItem: 0,
        agree: false,
        progressing: false,
        birthYear: '',
        birthMonth: '',
        birthDay: '',
        emailList,
        joinPurpose,
        applyPath,
        etcEmailAddress: '',
        allCheck: false,
        motive: '',
        channel: '',
        email1: '',
        email2: '',
        channelEtc: '',
        motiveEtc: '',
        occuPation: [],
        occuPationStr: '',
        occuList,
        occuEtcVal: '',
        emailCheck: 'Y',
        smsCheck: 'Y',
        emailCheckList,
        smsCheckList,
      };
    },
    computed: {
    },
    methods: {
      checked(event) {
        if (event.key === "'") {
          alert("'는 사용 하실 수 없습니다.");
          this.channelEtc = this.channelEtc.replace("'", '');
          this.motiveEtc = this.motiveEtc.replace("'", '');
          this.occuEtcVal = this.occuEtcVal.replace("'", '');
          this.member.addr2 = this.member.addr2.replace("'", '');
        }
      },
      onClick(obj) {
        if (this.occuPationStr === obj) {
          this.member.occuPation = [];
          this.occuPation = [];
          this.occuPationStr = '';
        } else {
          this.member.occuPation = [obj];
          this.occuPation = [obj];
          this.occuPationStr = obj;
        }
      },
      goToStep2() {
        this.step = 2;
        document.title = '교육|수강신청|강좌정보|서울시 50플러스포털';
        $('html, body').animate({ scrollTop: `${$('#buttons-tab').offset().top}px` }, 'fast');
      },
      goToStep3() {
        if (this.step === 2) {
          if (this.application.motive === '' || this.answers.filter(answer => answer === null || answer.length === 0).length !== 0) {
            alert('모든 질문에 답변해 주세요.');
            this.$refs.motive.focus();
            return;
          } else if (this.application.motive.length > 1000) {
            alert('답변은 1000자 이하로 작성해주세요.');
            this.$refs.motive.focus();
            return;
          } else if (this.answers.filter(answer => answer.length > 1000).length !== 0) {
            alert('서술형 답변은 1000자 이하로 작성해주세요.');
            return;
          }
        }

        this.step = 3;
        document.title = '교육|수강신청|등록|서울시 50플러스포털';
        $('html, body').animate({ scrollTop: `${$('#buttons-tab').offset().top}px` }, 'fast');
      },
      goToPrevious() {
        this.step -= 1;
        $('html, body').animate({ scrollTop: `${$('#buttons-tab').offset().top}px` }, 'fast');
      },
      updateInfo() {
        if (!this.email2 || !this.email1) {
          alert('이메일을 입력해 주세요.');
        } else if (!this.member.phone1 || !this.member.phone2 || !this.member.phone3) {
          alert('연락처를 입력해 주세요.');
        } else if (!this.member.zipcode || !this.member.addr1 || !this.member.addr2) {
          alert('주소를 입력해 주세요.');
        } else if (!this.channel || (this.channel === 'etc' && !this.channelEtc)) {
          alert('가입경로를 입력해 주세요.');
        } else if (!this.motive || (this.motive === 'etc' && !this.motiveEtc)) {
          alert('가입동기 및 희망분야를 입력해 주세요.');
        } else if (!this.occuPationStr || this.occuPationStr === '') {
          alert('주된 직업군을 선택해 주세요.');
          $('select[v-model="occuPationStr"]').focus();
        } else if (!this.likeOrgs) {
          alert('나의 관심 50+를 최소 한 개의 선택이 필요합니다.');
          $('#like-orgs').focus();
        } else if (this.member.likeOrgs.length === 0) {
          alert('나의 관심 50+를 최소 한 개의 선택이 필요합니다.');
          $('#like-orgs').focus();
        } else {
          const email2 = this.email2 !== 'etc' ? this.email2 : this.etcEmailAddress;
          const channel = this.channel !== 'etc' ? this.channel : this.channelEtc;
          const motive = this.motive !== 'etc' ? this.motive : this.motiveEtc;
          const mail = `${this.email1}@${email2}`;
          const etc = this.occuPationStr.substring(0, 2);
          if (etc === '기타') {
            const front = '기타(';
            const end = ')';
            this.occuPationStr = front + document.getElementById('occuEtc').value + end;
            this.occuEtcVal = document.getElementById('occuEtc').value;
          }
          if (this.occuPationStr === '') {
            this.occuPationStr = this.member.occuPation.toString();
          }
          const Params = {
            email: mail,
            birthdate: this.member.birthdate,
            phone1: this.member.phone1,
            phone2: this.member.phone2,
            phone3: this.member.phone3,
            zipcode: this.member.zipcode,
            addr1: this.member.addr1,
            addr2: this.member.addr2,
            gender: this.member.gender,
            applyPath: channel,
            joinPurpose: motive,
            likeOrgs: this.member.likeOrgs,
            photoUrl: this.member.photoUrl,
            occuPation: this.occuPationStr,
            emailCheck: this.emailCheck,
            smsCheck: this.smsCheck,
          };
          axios.put('/api/members/info', Params).then(() => {
            // alert('수정되었습니다.');
            this.goToStep2();
          }).catch((e) => {
            alert(e.response.data.msg);
          });
        }
      },
      imgUrlChange(id) {
        const that = this;
        const formid = `#form${id}`;
        $(formid).ajaxSubmit({
          dataType: 'json',
          error: (err) => {
            alert(err.msg);
          },
          success: (response, statusText, xhr) => {
            if (xhr.status === 401) {
              alert('로그아웃 상태입니다.');
              location.href = '/login.do';
            } else if (xhr.status < 400) {
              that.member.photoUrl = response.filename;
            } else {
              alert(statusText);
            }
          },
        });
      },
      apply() {
        if (this.discount === 'ETC' && !this.discountEtc) {
          alert('기타 내용을 입력해 주세요.');
          return;
        }
        if (!this.agree) {
          alert('신청하시려면 내용에 동의가 필요합니다.');
          return;
        }
        if (this.progressing) return;
        this.progressing = true;
        this.application.discount = this.discount === 'ETC' ? this.discountEtc : this.discount;
        this.application.forms = this.answers.map((answer, index) => {
          const newItem = {
            seq: index,
            question: this.forms[index].question,
            answer: JSON.stringify(answer),
          };
          return newItem;
        });
        axios.post(`/api/lectures/${this.lecture.id}`, this.application).then((res) => {
          this.progressing = false;
          location.href = this.lecture.orgType === 'PORTAL' ? `/education-pay.do?id=${res.data}` : `/${this.lecture.org}/education-pay.do?id=${res.data}`;
        }).catch((e) => {
          this.progressing = false;
          alert(e.response.data.msg);
        });
      },
      motiveValue() {
        const purpose = this.joinPurpose.filter(item => item === this.member.joinPurpose);
        if (purpose && purpose.length > 0) {
          this.motive = this.member.joinPurpose;
        } else {
          this.motive = 'etc';
          this.motiveEtc = this.member.joinPurpose;
        }
      },
      channelValue() {
        const route = this.applyPath.filter(item => item === this.member.applyPath);
        if (route && route.length > 0) {
          this.channel = this.member.applyPath;
        } else {
          this.channel = 'etc';
          this.channelEtc = this.member.applyPath;
        }
      },
      emailValue() {
        this.email1 = this.member.email.split('@')[0];
        const emailAddress = this.member.email.split('@')[1];
        let isSame = false;
        emailList.forEach((item) => {
          if (item === emailAddress) isSame = true;
          else if (item !== emailAddress) {
            this.etcEmailAddress = emailAddress;
          }
        });
        if (isSame) this.email2 = emailAddress;
        else this.email2 = 'etc';
      },
      motiveChange() {
        if (this.motive === 'etc') {
          document.getElementById('joinMotiveEtc').style.display = 'block';
        } else {
          document.getElementById('joinMotiveEtc').style.display = 'none';
        }
      },
      emailChange() {
        if (this.email2 === 'etc') {
          document.getElementById('emailSelectBoxDirect').style.display = 'block';
        } else {
          document.getElementById('emailSelectBoxDirect').style.display = 'none';
        }
      },
      channelChange() {
        if (this.channel === 'etc') {
          document.getElementById('joinChannelEtc').style.display = 'block';
        } else {
          document.getElementById('joinChannelEtc').style.display = 'none';
        }
      },
      chkAllOrgs() {
        if (this.allCheck) {
          this.orgCode.forEach((item) => {
            this.member.likeOrgs.push(item);
          });
        } else {
          this.member.likeOrgs = [];
        }
      },
      foldDaumPostcode() {
        const elementWrap = document.getElementById('wrap');
        const elementWrapTab = document.getElementById('wrapTab');
        // iframe을 넣은 element를 안보이게 한다.
        elementWrap.style.display = 'none';
        elementWrapTab.style.display = 'none';
      },
      foldDaumPostcodeEnter() {
        const elementWrap = document.getElementById('wrap');
        const elementWrapTab = document.getElementById('wrapTab');
        // iframe을 넣은 element를 안보이게 한다.
        elementWrap.style.display = 'none';
        elementWrapTab.style.display = 'none';
      },
      findAddress() {
        const thisVal = this;
        const elementWrap = document.getElementById('wrap');
        const elementWrapTab = document.getElementById('wrapTab');
        // 현재 scroll 위치를 저장해놓는다.
        const currentScroll = Math.max(document.body.scrollTop, document.documentElement.scrollTop);
        daum.postcode.load(() => {
          new daum.Postcode({
            oncomplete(data) {
              // 검색결과 항목을 클릭했을때 실행할 코드를 작성하는 부분.

              // 각 주소의 노출 규칙에 따라 주소를 조합한다.
              // 내려오는 변수가 값이 없는 경우엔 공백('')값을 가지므로, 이를 참고하여 분기 한다.
              let fullAddr = data.address; // 최종 주소 변수
              let extraAddr = ''; // 조합형 주소 변수

              // 기본 주소가 도로명 타입일때 조합한다.
              if (data.addressType === 'R') {
                // 법정동명이 있을 경우 추가한다.
                if (data.bname !== '') {
                  extraAddr += data.bname;
                }
                // 건물명이 있을 경우 추가한다.
                if (data.buildingName !== '') {
                  extraAddr += (extraAddr !== '' ? `,${data.buildingName}` : data.buildingName);
                }
                // 조합형주소의 유무에 따라 양쪽에 괄호를 추가하여 최종 주소를 만든다.
                fullAddr += (extraAddr !== '' ? `(${extraAddr})` : '');
              }

              // 우편번호와 주소 정보를 해당 필드에 넣는다.
              // 5자리 새우편번호 사용
              // document.getElementById('postcode').value = data.zonecode;
              thisVal.member.addr1 = fullAddr;
              thisVal.member.zipcode = data.zonecode;

              // iframe을 넣은 element를 안보이게 한다.
              // (autoClose:false 기능을 이용한다면, 아래 코드를 제거해야 화면에서 사라지지 않는다.)
              elementWrap.style.display = 'none';
              elementWrapTab.style.display = 'none';

              // 우편번호 찾기 화면이 보이기 이전으로 scroll 위치를 되돌린다.
              document.body.scrollTop = currentScroll;
            },
            // 우편번호 찾기 화면 크기가 조정되었을때 실행할 코드를 작성하는 부분. iframe을 넣은 element의 높이값을 조정한다.
            onresize(size) {
              elementWrap.style.height = `${size.height}px`;
            },
            width: '100%',
            height: '100%',
          }).embed(elementWrap);
        });
        // iframe을 넣은 element를 보이게 한다.
        elementWrap.style.display = 'block';
        elementWrapTab.style.display = 'block';

        setTimeout(() => {
          const iframeTb = document.getElementById('__daum__layer_1');
          const iframeTt = iframeTb.getElementsByTagName('iframe');
          for (let i = 0; i < iframeTt.length; i += 1) {
            iframeTt[i].title = '우편번호정보프레임';
          }
        }, 1000);
      },
      occuPationEtc() {
        const str = this.member.occuPation.toString();
        const etc = str.substring(0, 2);
        if (etc === '기타') {
          const left = str.indexOf('(');
          const right = str.indexOf(')');
          const sub = str.substring(left, right);
          const len = sub.length;
          const subPlus = sub.substring(1, len);
          document.getElementById('occuEtc').value = subPlus;
          this.occuEtcVal = subPlus;
          this.member.occuPation = [etc];
          this.occuPationStr = etc;
        }
      },
    },
    created() {
      this.answers = this.forms.map((form) => {
        if (form.type === 'MULTI') return [];
        return null;
      });
      if (this.member.birthdate) {
        this.birthYear = `19${this.member.birthdate.substr(0, 2)}`;
        this.birthMonth = this.member.birthdate.substr(2, 2);
        this.birthDay = this.member.birthdate.substr(4, 2);
      }
    },
    mounted() {
      this.emailValue();
      this.motiveValue();
      this.channelValue();
      this.motiveChange();
      this.channelChange();
      this.emailChange();
      this.occuPationEtc();
    },
  };
</script>
<style lang="scss">
</style>


// WEBPACK FOOTER //
// CourseFormJobType.vue?a8d08748